import _ from "lodash";
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { usePrevious } from "Hooks";
import ACLStore from "lib/aclStore";
import withDerivedProps from "lib/withDerivedProps";
import PropTypes from "prop-types";
import ACLStorage from "lib/aclService";
import { ASSESSMENT_TOOLS } from "@toddle-edu/common-utils";

// Components
import UIModal from "UIComponents/UIModal";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import withLoader from "UIComponents/GqlWithLoader";
import I18nHOC from "UIComponents/I18nHOC";
import Transition from "UIComponents/Transition";
import Header from "./Header";
import AssignmentSettings from "./AssignmentSettings";
import LessonPlanningAssistant from "./LessonPlanningAssistant";
import AiQuestionAssistant from "./AiQuestionAssistant";
import WithOnlySettingStep from "./WithOnlySettingStep";
import StepContainer from "./StepContainer";
import CompactUIFooter from "./CompactUIFooter";
import Worksheet from "Worksheet";
import AssessmentDraftModal from "AppComponents/CreateOrEditAssignment/AssessmentDraftModal";
import StepHeader from "AppComponents/StepHeader";
import DownloadWorksheetModal from "Worksheet/components/DownloadWorksheetModal";
import withControlParameters from "lib/aclService/hoc/withControlParameters";

// DS
import { Alert, Button, Dialog, Modal, DSProvider } from "@toddle-edu/ds-web";

// Modules

import {
  getAssignmentEditDetailsQuery,
  getLearningCourseDetailsQuery,
} from "ClassRoom/modules/ClassRoomQuery";
import { getMultiCourseStudentsFoldersFromCache } from "Course/modules/CourseGraphqlHelpers";
import { getCurrentAssessmentTypes } from "Platform/modules/PlatformModule";
import { getUnitPlanDetails } from "IBPlanner/modules/IBPlannerModule";
import {
  createAssignment,
  updateAssignment,
  updateCourseId,
  setCourseId,
  isMaxScoreValid,
  getSimilarityIndexDefaultValue,
  updateScoreAndEvaluation,
  getAssignmentStateTabs,
  updateClassRoomFilters,
  getStaffCoursesBasicDetails,
  getLearningCourseDetails,
  setCourseFlowResourceDataForRefetch,
} from "ClassRoom/modules/ClassRoomModule";
import {
  createAssessment,
  cloneAssessment,
  deleteClonedAssessment,
  updateAssessmentInCache,
  getAssessmentDataFromLocalStorage,
  updateAIDataInRedux,
  updateAssessment,
  deleteAssessment,
  createCourseFlowResources,
  createCourseFlowResourceInsideUnit,
} from "Assessments/modules/AssessmentModule";
import { getAssessmentDetailsFromCache } from "Assessments/modules/AssessmentGraphqlHelpers";
import {
  getCourseStudentsFoldersQuery,
  getMultiCourseStudentsFoldersQuery,
} from "Course/modules/CourseQuery";
import {
  setToastMsg,
  getUserInfo,
  enableGlobalHeader,
  disableGlobalHeader,
} from "Login/modules/LoginModule";
import {
  getSelectedAcademicYearId,
  getSelectedCurriculumId,
  getSelectedCurriculumProgram,
  getCurrentAcademicYear,
} from "modules/CommonSelectors";
import { updateIsTeacherPreviewModeEnabled } from "Worksheet/modules/WorksheetModules";
import { getIsConfigurationEnabledForCPAY } from "modules/PermissionModule";
import { getSettingValue } from "Utils/ConfigurationUtils";
import { getStaffCoursesV2BasicDetailsQuery } from "Teacher/modules/TeacherQuery";
import {
  setConfirmationDialogData as setClassFlowConfirmationModalData,
  updateUserClassFlowSettings,
  USER_CLASS_FLOW_SETTING_OPTIONS,
} from "ClassMaterials/modules/ClassMaterialsModule";
import { deleteCourseFlowResources } from "CourseFlow/modules/CourseFlowModule";
import { updateTimetableSlotItems } from "TimetablePlanner/modules/TimetablePlannerModule";
import { setLtiAttachmentDeleted } from "../../../UnitPlans/components/Assessments/modules/AssessmentModule/AssessmentActions";
// Utils
import {
  removeAssessmentFromLocalStorage as _removeAssessmentFromLocalStorage,
  getUnitPlanFromAssessment,
  setAssessmentInLocalStorage,
} from "Assessments/modules/Utils";
import { getInitialStep } from "Assessments/modules/AssessmentModule/AssessmentUtils";
import { LESSON_PLANNING_TRANSITION_PROPS } from "Assessments/modules/Constants";
import ConditionalWrapper from "Utils/ConditionalWrapper";
import {
  getFormattedCoursesDetails,
  getIsLessonPlanningEnabled,
  showUnitSelection,
  minutesToHoursAndMinutes,
  getShowLessonPlanningAIByDefault,
  getStaffCourseDetailsQueryVariables,
  getFilteredCoursesBasedOnViewOrManagePermission,
  getAssignmentConsumingParentModulesPermission,
  getFormattedCoursesDetailsMemoize,
  getAssignmentHasTeacherEvaluation,
} from "ClassRoom/modules/utils";
import { getCalendarEventsViewSettingValue } from "MyCalendar/modules/Utils";
import {
  getInitialSelectedState,
  getStepsInfo,
  getCourseAcademicYearsIds,
  getPreselectedCourseIds,
  getEditAssignmentInitialCoursesState,
  getSteps,
  getGenericFolders,
  getAddedCoursesData,
  getEditAssignmentMutationCoursesData,
  getTargetStep,
  getIsNavigatingToPreviousStep,
  generateDateTimeString,
} from "./Utils";
import { checkIsDateBefore } from "Utils/DateTimeHelpers";
import { getUserName } from "ToddleLibrary/modules/ToddleLibraryUtils";
import { joinWithCommaAnd } from "Utils/StringHelpers";
import { isSchoolLibraryRoute } from "SchoolLibrary/modules/Utils";
import { getSelectedLearningCourseId } from "LearningCourse/modules/Utils";
import { getIsLearningCoursesEnabled } from "LearningCourses/modules/Utils";
import { getIsWorksheetAssignModalV2Enabled } from "Worksheet/modules/WorksheetFeatureFlags";
import { getAddNewItemToTopPreference } from "Utils/EntityFlowUtils";
import { generateRnPContextsByLevel } from "Utils/RnPHelpers";
import {
  getIsEnabledAssignmentImprovements,
  getIsAITutorModalitiesEnabled,
  getIsAssignmentsUnitTaggingIn2_0Enabled,
} from "Utils/ACLStoreUtils";

// third party
import classNames from "classnames";
import moment from "moment";
import update from "immutability-helper";
import { compose, graphql } from "lib/apolloClient";
import { connect } from "react-redux";
// Constants
import {
  MODE_TEACHER_PREVIEW,
  ASSESSMENT_TYPE_WORKSHEET,
} from "Worksheet/modules/WorksheetConstants";
import { MY_CALENDAR_CONSTANTS } from "MyCalendar/constants/stringConstants";
import {
  GROUP_TYPE_WORKSHEET,
  CREATE_LE,
  CREATE_AI_TUTOR,
  CREATE_FA,
  CREATE_SA,
  CREATE_ASSESSMENT,
  CREATE_WORKSHEET,
  CREATE_WORKSHEET_FROM_TODDLE_LIBRARY,
  QUESTION_CREATION,
  ASSESSMENT_DETAILS,
  SETTINGS,
  IMPORT_IN_CLASS,
  IMPORT_LE_FROM_COMMUNITY,
  IMPORT_LE,
  IMPORT_LE_FROM_LE_LIBRARY,
  ASSIGN_TO_CLASS,
  IMPORT_LE_FROM_TODDLE_LIBRARY,
  IMPORT_TODDLE_LIBRARY_WORKSHEET_IN_CLASS,
  UNIT,
  UNIT_SELECTION,
  LE_CREATE_UNIT_SELECTION,
  FMT_CREATE_UNIT_SELECTION,
  SMT_CREATE_UNIT_SELECTION,
  WORKSHEET_UNIT_SELECTION,
  ASSESSMENT_CREATE_UNIT_SELECTION,
  LE_SELECTION,
  LE_LIBRARY_LE_SELECTION,
  COMMUNITY_LE_SELECTION,
  RESOURCE_SELECTION,
  UNIT_FROM_GRADE_SELECTION,
  DISCUSSION_CREATION,
  ASSESSMENT,
  SELECT_POST,
  TODDLE_LIBRARY_WORKSHEET_SELECTION,
  ASSIGNMENT_TYPE_SUMMATIVE,
  ASSIGNMENT_TYPE_FORMATIVE,
  ASSIGNMENT_TYPE_LE,
  LEARNING_ENGAGEMENT,
  ASSIGNMENT_TYPE_PERFORMANCE_TASK,
  SMT_CREATION,
  FMT_CREATION,
  LE_CREATION,
  AI_TUTOR_CREATION,
  QT_CREATION,
  ASSESSMENT_CREATION,
  CLASS_SELECTION,
  WORKSHEET_QUESTION_CREATION,
  ASSIGNMENT_TYPE_ASSIGNMENT_RESOURCE,
  PLANNER,
  CURRICULUM_VARIANT_TODDLE_PLAY,
  ASSESSMENT_TYPE_AI_TUTOR,
  VISIBLE,
  LEARNING_COURSE_SELECTION,
  OPENS_ON,
  TASK_TYPE_AI_TUTOR,
  TASK_TYPE_WORKSHEET,
} from "Constants/stringConstants";
import { EXCLUDED_ASSESSMENT_TYPES } from "store/static";
import {
  CAN_EDIT_COURSE_FLOW_PERMISSION,
  USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
} from "Constants/permissionConstants";

// Scss
import classes from "./AddAssignment.scss";
import { updateWeeklyPlannerSectionItems } from "ClassPlanners/modules/ClassPlannersModule";

let DiscussionPromptRef = null;
let assessmentDetailsRef = null;
let worksheetRef = null;

const EMPTY_ARRAY = [];

const CREATE_SCREENS = [
  CREATE_LE,
  CREATE_FA,
  CREATE_SA,
  CREATE_AI_TUTOR,
  CREATE_ASSESSMENT,
  CREATE_WORKSHEET,
  CREATE_WORKSHEET_FROM_TODDLE_LIBRARY,
];

const getDialogInfo = ({ assessmentTypeLabel, assessmentTitle }) => ({
  DISCARD: {
    title: t =>
      t("classRoom:discard_assessment", { label: assessmentTypeLabel }),
    message: t =>
      t("classRoom:discard_assessment_message", { type: assessmentTypeLabel }),
    confirmButtonText: t => t("common:discard_and_exit"),
    cancelButtonText: t => t("common:save_and_exit"),
  },
  DISCARD_ASSESSMENT: {
    title: t => t("classRoom:discard_assessment", { label: assessmentTitle }),
    message: t =>
      t("classRoom:discard_assessment_message", { type: assessmentTypeLabel }),
    confirmButtonText: t => t("common:discard_and_exit"),
    cancelButtonText: t => t("common:save_and_exit"),
  },
  UPDATE_AI_TUTOR: {
    title: t => t("ai:update_tutor"),
    message: t => t("ai:update_tutor_warning_msg"),
    cancelButtonText: t => t("common:cancel"),
    confirmButtonText: t => t("ai:update_tutor"),
    alertText: t => t("ai:update_tutor_alert_msg"),
  },
});

const footerButtonsWithSpaceStyle = {
  containerStyle: {
    paddingLeft: "32px",
    paddingRight: "32px",
  },
  innerContainerStyle: {
    maxWidth: "unset",
    marginRight: "528px",
  },
};

const styles = {
  modalHeaderStyle: {
    padding: "12px 16px",
  },
  modalBodyStyle: {
    padding: "16px",
  },
  modalFooterStyle: {
    padding: "12px 16px",
  },
};

const components = { b: <b /> };

const AddAssignment = React.memo(props => {
  const {
    t,
    steps: headerSteps,
    onClose: handleClose,
    mode,
    courseId,
    course,
    contentType,
    createHeader,
    editHeaderText,
    createAssignment,
    setToastMsg,
    assignmentData,
    assignmentContent,
    updateAssignment,
    creationMode,
    resourceSelection,
    onDoneResourceSelection,
    plannerAssignmentModalData,
    cloneAssessment,
    sourceAssessmentId,
    updateCourseId,
    portalType,
    deleteClonedAssessment,
    selectedTimeSlot,
    curriculumProgram,
    createAssessment,
    getUnitPlanDetails,
    preSelectedCoursesDetails,
    creationSource,
    refetchUpcomingEvents,
    courseList,
    assessmentType: _assessmentType,
    taskTypeGroup,
    pageName,
    assignmentId,
    assignmentDetails,
    showImageTitleInHeader,
    clonedAssessmentId = "",
    updateUnitPlanDataInRedux,
    courseAcademicYearsIds,
    showCalendarAssignmentByDueDate,
    setCourseId,
    grades,
    subjects,
    courseSubjects,
    curriculumType,
    isFromUnitPlan,
    initialStep,
    getAssessmentDataFromLocalStorage,
    isCommunity,
    isToddleLibrary,
    isSchoolLibrary,
    state,
    isSettingsStepOnly,
    showInModal,
    isWorksheet,
    customDeleteFunction,
    getSimilarityIndexDefaultValue,
    customFooterButton,
    isMaxScoreValid,
    defaultQuestionIds,
    updateScoreAndEvaluation,
    isDuplicateAssignment = false,
    creationSubSource,
    userName,
    platformUserId,
    curriculumProgramVariant,
    // used in class flow
    putAfterItemId,
    disableGlobalHeader,
    enableGlobalHeader,
    isGlobalHeaderVisible,
    assignedStudents,

    classFlowConfirmationDialogData,
    setClassFlowConfirmationModalData,
    updateUserClassFlowSettings,
    testId,
    updateIsTeacherPreviewModeEnabled,
    collaboratorsFilter,
    isGeneratingAIQuestions,
    createdAt,
    updateAssessment,
    sourceAssignmentId,
    metadata,
    updateClassRoomFilters,
    dueTimePreference,
    userId,
    learningCourseId: _learningCourseId,
    filteredStaffCourses,
    isLearningCoursesEnabled,
    isCourseFlow,
    learningCourseClasses,
    academicYearId,
    userType,
    getStaffCoursesBasicDetails,
    getLearningCourseDetails,
    setCourseFlowResourceDataForRefetch,
    currentCurriculumProgramId,
    deleteCourseFlowResources,
    courseFlowResourceData,
    deleteAssessment,
    showAssessmentLockIcon,
    isLocked,
    hasConflict,
    syncStatus,
    isUsingNewGradingSetupInCourses,
    assignmentDefaultSettings,
    getCurrentAssessmentTypes,
    assessmentMode, // In 2.0 when draft assessment edited from course plan/unit flow then assessmentMode is "edit" and mode is "create",
    sendAssignNotificationPreference,
    primaryGradeId: primaryGradeIdFromProps,
    isLtiAttachmentDeleted,
    createCourseFlowResources,
    updateWeeklyPlannerSectionItems,
    createCourseFlowResourceInsideUnit,
    updateTimetableSlotItems,
    dynamicAssessmentIcon,
    aiTutorSelectedTab,
    updateAIDataInRedux,
    assignmentTemplateId,
    assignmentTaskTypeId,
    isUnitRoute,
  } = props;

  //refs
  const isGlobalHeaderVisiblePrevRef = useRef(isGlobalHeaderVisible);
  const isAssignmentSettingsOpened = useRef(false);

  // states
  const [currentStep, setCurrentStep] = useState(
    initialStep || _.first(headerSteps)?.value
  );
  const [errorModalParams, setErrorModalParams] = useState(false);
  const [backDateModalParams, setBackDateModalParams] = useState(false);
  const [isNextDisabled, setIsNextDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadingStatus, setUploadingStatus] = useState(false);
  const [currentDialogueAction, setCurrentDialogueAction] = useState("");
  const [dialogBoxParams, setDialogBoxParams] = useState({});
  const [metaData, setMetaData] = useState({ submitted: false });
  const [currentDialogWithAlert, setCurrentDialogWithAlert] = useState("");
  const [currentClonedImportedLeId, setCurrentClonedImportedLeId] = useState(
    sourceAssessmentId || ""
  );
  const [isGeneratingAIResponse, setIsGeneratingAIResponse] = useState(false);

  const [isCommentPaneActive, setIsCommentPaneActive] = useState(false);
  const [commentCounts, setCommentCounts] = useState({
    totalCommentCount: 0,
    unreadCommentCount: 0,
  });

  const [showAssistantRightPane, setShowAssistantRightPane] = useState(
    getShowLessonPlanningAIByDefault() &&
      curriculumProgramVariant !== CURRICULUM_VARIANT_TODDLE_PLAY // lesson planning not available for toddle play
  );

  const [showSettingsModal, setShowSettingsModal] = useState(
    isSettingsStepOnly
  );

  const [showWorksheetPreviewModal, setShowWorksheetPreviewModal] = useState(
    false
  );

  const [showDownloadWorksheetModal, setShowDownloadWorksheetModal] = useState(
    false
  );
  const [selectedState, setSelectedState] = useState(() =>
    getInitialSelectedState({
      mode,
      resourceSelection,
      clonedAssessmentId,
      courseId,
      creationMode,
      assignmentData,
      contentType,
      sourceAssessmentId,
      isSimilarityCheckEnabledDefaultValue: getSimilarityIndexDefaultValue(),
      selectedTimeSlot,
      showCalendarAssignmentByDueDate,
      course,
      preSelectedCoursesDetails,
      isDuplicateAssignment,
      isSettingsStepOnly,
      creationSource,
      assessmentType: _assessmentType,
      userId,
      currentCurriculumProgramId: _.get(curriculumProgram, "id"),
      filteredStaffCourses,
      assignmentDefaultSettings,
      sendAssignNotificationPreference,
    })
  );

  const toddleLibraryPrimaryGradeId = isToddleLibrary
    ? _.get(selectedState, "selectedCourse.grades.0.id")
    : undefined;

  const learningCoursePrimaryGradeId = isLearningCoursesEnabled
    ? _.get(
        selectedState,
        "learningCourseSelectionState.selectedLearningCourse.primaryGrade.id"
      )
    : undefined;

  const primaryGradeId =
    primaryGradeIdFromProps ||
    learningCoursePrimaryGradeId ||
    toddleLibraryPrimaryGradeId;

  // HACK: To force re-render AddAssignment when getAssessment query is fetched in AssessmentDetails
  // This is for import from toddle library step else assessment type will be undefined and footer won't be visible
  // TODO: look for better solution
  const [isAssessmentFetched, setIsAssessmentFetched] = useState(false);

  // filteredStaffCourses is the list of staff courses(classes) of current learning-course
  // that staff has manage assignment/gradebook permission
  const [filteredStaffCoursesIds, setFilteredStaffCoursesIds] = useState(() =>
    _.map(filteredStaffCourses, "id")
  );
  const [learningCourseClassIds, setLearningCourseClassIds] = useState(() =>
    _.map(learningCourseClasses, "id")
  );

  // Refs
  const intervalRef = useRef(null);

  // prev values
  const prevLeId = usePrevious(selectedState.leId);
  const prevUnitPlanId = usePrevious(selectedState.unitPlanId);

  // Side effects

  useEffect(() => {
    if (isSettingsStepOnly) {
      return;
    }
    disableGlobalHeader();
    return () => {
      if (
        !isSettingsStepOnly &&
        !isGlobalHeaderVisible &&
        isGlobalHeaderVisiblePrevRef.current
      )
        enableGlobalHeader();
    };
  }, [isGlobalHeaderVisible]);

  useEffect(() => {
    if (!isLtiAttachmentDeleted) {
      return;
    }

    const currentCourses = _.get(selectedState, "courses", []);
    const updatedCourses = _.map(currentCourses, course => ({
      ...course,
      deadlineDate: null,
      deadlineTime: null,
      state: {
        ...course.state,
        scheduleDate: null,
        scheduleTime: null,
      },
    }));

    const currentPreferences = _.get(selectedState, "metadata.preferences", []);
    const updatedPreferences = _.without(currentPreferences, OPENS_ON);

    updateSelectedItems({
      courses: updatedCourses,
      metadata: { preferences: updatedPreferences },
    });

    setLtiAttachmentDeleted(false);
  }, [isLtiAttachmentDeleted, selectedState.courses]);

  // reset scheduleDate and scheduleTime local state if backdate is allowed or assignment is published draft
  useEffect(() => {
    const courses = _.get(selectedState, "courses", []);
    const state = _.get(_.first(courses), "state");
    const isDraft = _.get(state, "state") == "DRAFT";

    if (isDraft) {
      updateSelectedItems({
        courses: _.map(courses, course => {
          const currentState = _.get(course, "state");
          const scheduleDate = _.get(currentState, "scheduleDate");
          const scheduleTime = _.get(currentState, "scheduleTime");
          const isScheduleDateOfPast =
            !_.isNil(scheduleDate) &&
            !_.isNil(scheduleTime) &&
            moment(`${scheduleDate} ${scheduleTime}`).isBefore(moment());

          // If user has not selected Opens on date while creating draft assignment we
          // will consider present date and time while publishing the draft assignment and if they
          // have selected opens on then the time when the draft assignment was created will be considered
          const isPublishedDraft =
            _.get(currentState, "state") == "DRAFT" &&
            isScheduleDateOfPast &&
            !_.includes(
              _.get(selectedState, "metadata.preferences", []),
              OPENS_ON
            );

          return {
            ...course,
            state: {
              ...(course?.state || []),
              scheduleDate: isPublishedDraft ? null : scheduleDate,
              scheduleTime: isPublishedDraft ? null : scheduleTime,
            },
          };
        }),
      });
    }
  }, []);

  // check if assignment settings modal is opened atleast once when created from COURSE_FLOW
  // Based on this ref we will decide whether to create assignment or not
  useEffect(() => {
    if (showSettingsModal && isLearningCoursesEnabled && mode === "create") {
      isAssignmentSettingsOpened.current = true;
    }
  }, [showSettingsModal]);

  // init courses state in case of toddle library and community
  useEffect(() => {
    if (isToddleLibrary || isCommunity || isSchoolLibrary) {
      updateCourses(filteredStaffCourses);
    }
  }, [course, courseId]);

  // set assignment state in local state to prevent loss of user data if something breaks in between
  useEffect(() => {
    if (!_.isEmpty(selectedState.leId)) setupInterval();
    return () => cleanupInterval();
  }, [selectedState]);

  // whenever user changes unit after createAssessment then delete the cloned assessment (as new one will be created)
  useEffect(() => {
    if (_.includes(CREATE_SCREENS, creationMode)) {
      return;
    }

    shouldDeleteAssessmentClone();
  }, [selectedState.unitPlanId]);

  // whenever user changes unit after createAssessment (by going to prev. step) then reset leId and importedLeId
  useEffect(() => {
    const resetId =
      mode === "create" &&
      _.includes(currentStep, UNIT_SELECTION) &&
      prevUnitPlanId !== selectedState.unitPlanId;

    if (resetId) {
      updateSelectedItems({ leId: "", importedLeId: "" });
    }
  }, [selectedState.unitPlanId, prevUnitPlanId, currentStep]);

  useEffect(() => {
    return () => {
      updateCourseId("");
      if (!_.get(metaData, "submitted", false)) deleteAssessmentClone();
    };
  }, []);

  useEffect(() => {
    const setCoursesState = async () => {
      // this case will run only when you select multiple courses from calendar
      const selectedCourse = _.get(selectedState, "selectedCourse", {});
      if (!_.isEmpty(selectedCourse)) {
        const { assessmentId } = await getAssessmentDataFromLocalStorage({
          courseId: _.get(selectedCourse, "courseId"),
          creationMode,
        });

        if (!assessmentId && !resourceSelection && !showSettingsModal) {
          setTimeout(updateCourses());
        }
      }
    };

    setCoursesState();
  }, [resourceSelection, selectedState.selectedCourse, course]);

  useEffect(() => {
    const course = _.get(selectedState, "selectedCourse.courseId", "");
    setCourseId(course);
  }, [selectedState.selectedCourse]);

  useEffect(() => {
    if (mode === "edit") {
      window.history.pushState(null, document.title, window.location.href);
      window.addEventListener("popstate", browserBackCallBack);

      return () => {
        window.removeEventListener("popstate", browserBackCallBack);
      };
    }
  }, []);

  // check if next button needs to be disabled
  useEffect(() => {
    updateIsNextDisabled();
  }, [selectedState, currentStep, uploadingStatus]);

  useEffect(() => {
    return () => {
      setCourseFlowResourceDataForRefetch(null);
    };
  }, []);

  useEffect(() => {
    if (isLearningCoursesEnabled) {
      const contexts = generateRnPContextsByLevel({
        level: "LEARNING_COURSE",
        learningCourseId,
        curriculumProgramId: currentCurriculumProgramId,
        gradeId: primaryGradeId,
      });

      const canManageCourseFlow = ACLStorage.getPermissionValueByContext(
        CAN_EDIT_COURSE_FLOW_PERMISSION,
        _.first(contexts)
      );

      if (!canManageCourseFlow && !isToddleLibrary) {
        updateSelectedItems({ isIncludedInCourseFlow: false });
      }
    }
  }, []);

  const {
    hasBothOpenAndDueDateBackdated = false,
    backDateCourses = [],
  } = backDateModalParams;

  const assessmentDetails = getAssessmentDetailsFromCache({
    id: selectedState.leId,
    collaboratorsFilter,
  });

  const assessmentType =
    _assessmentType ||
    _.get(assessmentDetails, "assessmentType.value") ||
    selectedState?.clonedAssessmentType;

  const assessmentTitle = _.get(assessmentDetails, "title.value", "");

  const isAITutor =
    taskTypeGroup === TASK_TYPE_AI_TUTOR ||
    assessmentType === ASSESSMENT_TYPE_AI_TUTOR;

  const isWorksheetCreateEditMode =
    _.includes(["create", "edit"], mode) &&
    (_.isEqual(assessmentType, ASSESSMENT_TYPE_WORKSHEET) ||
      _.isEqual(taskTypeGroup, TASK_TYPE_WORKSHEET) ||
      isWorksheet);
  const isWorksheetCreationStep =
    isWorksheetCreateEditMode &&
    _.includes([WORKSHEET_QUESTION_CREATION, ASSESSMENT_DETAILS], currentStep);

  // when importing from library, if user selects worksheet then we need to append worksheet questions step
  const steps = getSteps({
    t,
    headerSteps,
    assessmentType,
    isSettingsStepOnly,
    isWorksheetCreateEditMode,
  });

  const hideUnitSelection = !showUnitSelection({ creationMode });

  const learningCourseId =
    _learningCourseId ||
    _.get(
      selectedState,
      "learningCourseSelectionState.selectedLearningCourse.id",
      null
    );

  const isSingleAssessmentCopy = ACLStore.can(
    "FeatureFlag:SingleAssessmentCopy"
  );

  const isValid = params => {
    const { checkForInvalidQuestions = false } = params || {};
    const errorCount = assessmentDetailsRef?.step?.middlePane?.isValid();

    if (errorCount > 0) {
      setToastMsg({
        msg: "toastMsgs:please_rectify_errors_with_count",
        locale_params: [{ key: "count", value: errorCount, isPlainText: true }],
      });

      return false;
    }

    if (
      isWorksheetCreationStep &&
      _.has(worksheetRef, "isWorksheetValid") &&
      !worksheetRef?.isWorksheetValid?.({
        checkForInvalidQuestions,
        isCreateMode: mode === "create" || state === "DRAFT",
      })
    ) {
      return false;
    }

    return true;
  };

  const shouldUpdateAITabState =
    getIsAITutorModalitiesEnabled() &&
    assessmentType === ASSESSMENT_TYPE_AI_TUTOR &&
    aiTutorSelectedTab === "CHAT";

  const handleSaveAsDraft = async () => {
    const courses = _.get(selectedState, "courses", []);
    const assignmentLevelPreferences = _.get(
      selectedState,
      "metadata.preferences",
      []
    );
    const isDraftMode = mode === "create" || state === "DRAFT";

    if (isValid()) {
      if (isDraftMode) {
        if (checkIsDueDateBeforeScheduleDate()) {
          toggleErrorModal({ isAssignClicked: false });
          return;
        }
        const onClickDoneParams = {
          assessmentState: "DRAFT",
          shouldSelectAtleastOneStudent: false,
          saveAsDraftFromFooter: true,
          hideSuccessToast: true,
          showDraftToast: true,
        };
        onClickDone(onClickDoneParams);
      } else {
        onClose();
      }
    } else {
      setCurrentDialogueAction("");
    }
  };

  const changeCurrentStep = async value => {
    if (mode == "create") {
      switch (value) {
        case ASSESSMENT_DETAILS:
        case SETTINGS: {
          switch (creationMode) {
            case IMPORT_IN_CLASS:
            case IMPORT_LE_FROM_COMMUNITY:
            case IMPORT_LE:
            case IMPORT_LE_FROM_LE_LIBRARY:
            case ASSIGN_TO_CLASS:
            case IMPORT_LE_FROM_TODDLE_LIBRARY:
            case IMPORT_TODDLE_LIBRARY_WORKSHEET_IN_CLASS: {
              if (!selectedState.importedLeId) {
                setToastMsg("toastMsgs:select_le");
                return;
              }

              switch (creationMode) {
                case IMPORT_IN_CLASS:
                case IMPORT_LE_FROM_LE_LIBRARY:
                case ASSIGN_TO_CLASS:
                case IMPORT_TODDLE_LIBRARY_WORKSHEET_IN_CLASS:
                  if (!courseId) {
                    const toastMsg =
                      isToddleLibrary && isLearningCoursesEnabled
                        ? "toastMsgs:select_learning_course"
                        : "toastMsgs:select_course";
                    setToastMsg(toastMsg);
                    return;
                  }
                  break;
              }

              // In case of import from unit, if single assessment copy is enabled then
              // do not import assessment, assign same assessment in class
              const response = await createAssessmentClone({
                shouldNotCloneAssessment:
                  isSingleAssessmentCopy && creationMode === IMPORT_LE,
              });

              if (!response) return;

              break;
            }
            case UNIT: {
              if (!_.get(selectedState, "importedLeId")) {
                setToastMsg("toastMsgs:select_le");
                return;
              }
            }
          }
        }
      }
    }

    setTimeout(() => setCurrentStep(value), 100);
  };

  // set current assignment data to local storage every 2.5 sec to prevent loss of user data if something breaks in between
  const setupInterval = () => {
    if (mode === "view" || isCommunity || isToddleLibrary || isCourseFlow)
      return;

    intervalRef.current = setInterval(() => {
      setAssessmentInLocalStorage({
        courseId: courseId || _.get(selectedState, "selectedCourse.courseId"),
        value: {
          data: _.cloneDeep(selectedState),
          assessmentType,
          curriculumType,
          creationMode,
          currentStep,
        },
      });
    }, 2500);
  };

  // cleanup the interval on unmount
  const cleanupInterval = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  const browserBackCallBack = () => {
    window.history.pushState(null, document.title, window.location.href);

    if (isValid()) onClose();
  };

  const removeAssessmentFromLocalStorage = useCallback(() => {
    const _courseId =
      courseId || _.get(selectedState, "selectedCourse.courseId", {});

    _removeAssessmentFromLocalStorage({
      courseId: _courseId,
      curriculumType,
      assessmentType,
      creationMode,
    });
  }, [courseId, selectedState, curriculumType, creationMode]);

  const deleteTimetablePlannerResource = async () => {
    if (_.isEmpty(courseFlowResourceData)) {
      return;
    }
    const {
      resourceId,
      timetableType,
      selectedStaffId,
      timetableSlotId,
      itemType,
    } = courseFlowResourceData;

    const removedItem = {
      id: resourceId,
      itemType: itemType,
    };

    await updateTimetableSlotItems({
      items: { removed: [removedItem] },
      timetableSlotId,
      timetableType,
      selectedStaffId,
      showToast: false,
    });
  };

  const _deleteCourseFlowResource = async () => {
    if (_.isEmpty(courseFlowResourceData)) {
      return;
    }

    const resourceId = _.get(courseFlowResourceData, "resourceId");
    const groupType = _.get(
      courseFlowResourceData,
      "groupType",
      "LEARNING_ENGAGEMENT"
    );

    // source set in redux from CourseFlow and V3/UnitFlow component
    const source = _.get(courseFlowResourceData, "source");

    if (source === "TIMETABLE_PLANNER") {
      deleteTimetablePlannerResource();
      await deleteCourseFlowResources({
        ids: [resourceId],
        isSection: false,
        deleteLinkedCopies: true,
        groupType,
      });
      return;
    }

    if (source === "UNIT_FLOW") {
      await deleteAssessment({ assessmentId: prevLeId });
      return;
    }

    await deleteCourseFlowResources({
      ids: [resourceId],
      isSection: false,
      deleteLinkedCopies: true,
      groupType,
    });
  };

  const onClose = async params => {
    const {
      deleteClonedAssessment = false,
      isSuccess = false,
      deleteCourseFlowResource = false,
    } = params || {};

    if (customDeleteFunction) {
      customDeleteFunction({ prevLeId });
      removeAssessmentFromLocalStorage();
      return;
    }

    if (deleteClonedAssessment && !resourceSelection) {
      deleteAssessmentClone();
    }

    if (deleteCourseFlowResource && !resourceSelection) {
      setIsLoading(true);
      await _deleteCourseFlowResource();
      setIsLoading(false);
    }

    removeAssessmentFromLocalStorage();
    handleClose(isSuccess);
  };

  const getDiscussionPromptRef = useCallback(ref => {
    DiscussionPromptRef = ref;
  }, []);

  const setAssessmentDetailsRef = useCallback(ref => {
    assessmentDetailsRef = ref;
  }, []);

  const setWorksheetRef = useCallback(ref => {
    worksheetRef = ref;
  }, []);

  const handleCommentActiveChange = useCallback(isActive => {
    setIsCommentPaneActive(isActive);
  }, []);

  const handleCommentCountsChange = useCallback(counts => {
    setCommentCounts(prev =>
      prev.totalCommentCount === counts.totalCommentCount &&
      prev.unreadCommentCount === counts.unreadCommentCount
        ? prev
        : counts
    );
  }, []);

  const handleCommentClick = useCallback(() => {
    assessmentDetailsRef?.onCommentClick?.();
  }, []);

  const onResourceSelectionDone = () => {
    onDoneResourceSelection(_.get(selectedState, "resource.attachments", []));
    onClose();
  };

  const updateCourses = (filteredStaffCourses = []) => {
    if (mode === "create") {
      const selectedTimeSlotStartDate = _.get(
        selectedTimeSlot,
        "startDate",
        null
      );

      const selectedTimeSlotStartTime = _.get(
        selectedTimeSlot,
        "startTime",
        null
      );

      setSelectedState(prev => {
        const courses = _.get(prev, "courses", []);

        const selectedCourseId = _.get(
          selectedState,
          "selectedCourse.courseId"
        );

        let courseValue;

        if (selectedCourseId) {
          courseValue = _.find(
            preSelectedCoursesDetails,
            item => item.id == selectedCourseId
          );
        } else {
          courseValue = _.cloneDeep(course);
        }
        const courseKey =
          isToddleLibrary && isLearningCoursesEnabled
            ? "learningCourses"
            : "courses";
        return {
          ...prev,
          [courseKey]: !_.isEmpty(filteredStaffCourses)
            ? getFormattedCoursesDetailsMemoize({
                courses: filteredStaffCourses,
                selectedTimeSlot,
                itemType: "ASSIGNMENT",
                showCalendarAssignmentByDueDate,
              })
            : !_.isEmpty(courseValue)
            ? [
                {
                  id: courseValue.id,
                  title: courseValue.title,
                  students: _.map(
                    _.get(courseValue, "students.edges", []),
                    student => student.node
                  ),
                  totalStudents: _.map(
                    _.get(courseValue, "students.edges", []),
                    student => student.node
                  ),
                  deadlineDate: showCalendarAssignmentByDueDate
                    ? selectedTimeSlotStartDate
                    : null,
                  deadlineTime:
                    showCalendarAssignmentByDueDate && selectedTimeSlotStartTime
                      ? moment(selectedTimeSlotStartTime, "HH:mm")
                          .add(30, "minutes")
                          .format("HH:mm")
                      : null,
                  state: {
                    state: "PUBLISHED",
                    scheduleDate: _.get(
                      _.first(courses),
                      "state.scheduleDate",
                      null
                    ),
                    scheduleTime: _.get(
                      _.first(courses),
                      "state.scheduleTime",
                      null
                    ),
                  },
                  closeSubmissionDate: null,
                  visibility: VISIBLE,
                },
              ]
            : getFormattedCoursesDetails({
                courses: preSelectedCoursesDetails,
                selectedTimeSlot,
                itemType: "ASSIGNMENT",
                showCalendarAssignmentByDueDate,
              }),
        };
      });
    }
  };

  const onClickDone = async data => {
    const {
      assessmentState,
      shouldSelectAtleastOneStudent = true,
      genericFolders = [],
      saveAsDraftFromFooter = false,
      backDateCourses = [],
      hideSuccessToast,
      showDraftToast,
    } = data || {};

    /**
     * If assessment is getting created from course flow in new course setup then do not create assignment if...
     * 1. User has not selected any class in assign modal
     * 2. User has clicked on save as draft from footer without opening assign modal
     */
    const ignoreClassSelection =
      isLearningCoursesEnabled &&
      isCourseFlow &&
      (_.isEmpty(selectedState.courses) ||
        (saveAsDraftFromFooter && !isAssignmentSettingsOpened.current));

    if (mode === "create" && ignoreClassSelection) {
      onClose({ isSuccess: true });
      return;
    }

    const ignoreClassSelectionInToddleLibrary =
      isToddleLibrary &&
      isLearningCoursesEnabled &&
      assessmentState === "DRAFT";

    if (
      _.isEmpty(selectedState.courses) &&
      !ignoreClassSelection &&
      !ignoreClassSelectionInToddleLibrary
    ) {
      setToastMsg("toastMsgs:please_add_atleast_one_class_error");
      return;
    }

    removeAssessmentFromLocalStorage();

    // check if all selected classes have atleast one student tagged
    const courses = _.get(selectedState, "courses", []);
    const allCoursesHaveStudents = _.reduce(
      courses,
      (result, course) => {
        const students = _.get(course, "students", []);
        return (result = result && !_.isEmpty(students));
      },
      true
    );

    if (!allCoursesHaveStudents && shouldSelectAtleastOneStudent) {
      setToastMsg("toastMsgs:please_select_atleast_one_student_error");
      return;
    }

    const genericFoldersLocal = getGenericFolders({
      mode,
      courses,
      folderNames: selectedState?.folderNames,
      genericFolders,
    });

    let isScheduledAssignment = false;
    let sendObj = { ..._.omit(selectedState, ["unitPlanId"]) };

    const assessmentDetails = getAssessmentDetailsFromCache({
      id: selectedState.leId,
      collaboratorsFilter,
    });

    if (isToddleLibrary && isLearningCoursesEnabled) {
      setIsLoading(true);
      await createCourseFlowResources({
        learningCourseId,
        resources: [
          {
            label: "",
            itemId: _.get(assessmentDetails, "id", ""),
            itemType: "ASSESSMENT",
          },
        ],
        isDraft: assessmentState === "DRAFT",
      });

      setIsLoading(false);
      if (assessmentState === "DRAFT") {
        onClose({ isSuccess: true });
        return;
      }
    }
    if (creationSource == "CLASS_PLANNER" && !isLearningCoursesEnabled) {
      const sectionId = _.get(plannerAssignmentModalData, "sectionId");
      const classPlannerId = _.get(
        plannerAssignmentModalData,
        "classPlannerId"
      );

      setIsLoading(true);
      const { error } = await updateWeeklyPlannerSectionItems({
        sectionId,
        classPlannerId,
        editItems: {
          added: [
            { id: _.get(assessmentDetails, "id", ""), itemType: "ASSESSMENT" },
          ],
        },
      });
      setIsLoading(false);
      onClose({ isSuccess: error ? false : true });
      return;
    }

    const isLearningGoalsEvaluationEnabled = _.get(
      assessmentDetails,
      "isLearningGoalsEvaluationEnabled",
      false
    );

    const assessmentTools = _.get(
      assessmentDetails,
      "assessmentTools.edges",
      []
    );

    const assessmentToolsWithEval = _.filter(assessmentTools, ({ node }) => {
      const assessmentToolType = _.get(node, "assessmentToolType", "");
      return _.get(
        _.find(ASSESSMENT_TOOLS, ({ type }) => type === assessmentToolType),
        "hasEvaluation",
        false
      );
    });

    const someToolsHaveTeacherEval = getAssignmentHasTeacherEvaluation({
      isLearningGoalsEvaluationEnabled,
      assessmentTools,
    });

    const someToolsHaveStudentEval = _.some(
      assessmentToolsWithEval,
      ({ node }) => _.get(node, "isStudentEvaluationEnable", false)
    );

    sendObj["isTeacherEvaluationEnabled"] = someToolsHaveTeacherEval ?? false;
    sendObj["isStudentEvaluationEnabled"] = someToolsHaveStudentEval ?? false;

    const isTimedTestEnabled = _.get(
      selectedState,
      "isTimedTestEnabled",
      false
    );

    if (!isTimedTestEnabled) {
      sendObj = _.omit(sendObj, ["timedTestDuration"]);
    } else {
      const { hours, minutes } = _.get(selectedState, "timedTestDuration", {});
      sendObj["timedTestDuration"] = hours * 60 + minutes;
    }

    // When WorksheetAssignModalV2 is enabled, security mode and duration are sent
    // per-class inside the courses array, so remove them from the root payload
    if (getIsWorksheetAssignModalV2Enabled()) {
      sendObj = _.omit(sendObj, [
        "isLockScreenEnabled",
        "isSafeBrowserEnabled",
        "timedTestDuration",
      ]);
    }

    if (assessmentState === "DRAFT") {
      sendObj = { ...sendObj, isLockSubmissionEnabled: false };
    }

    const isStudentSubmissionEnabled = _.get(
      selectedState,
      "isStudentSubmissionEnabled",
      false
    );
    if (
      !ACLStore.can("FeatureFlag:ShowAssignNotificationPreference") ||
      isStudentSubmissionEnabled ||
      _.includes(["PUBLISHED", "ARCHIVED"], state)
    ) {
      sendObj = _.omit(sendObj, ["isSendAssignedNotification"]);
    }

    if (mode == "create") {
      const { courses, isScheduled } = getAddedCoursesData({
        addedCourses: _.get(selectedState, "courses", []),
        metadata: _.get(selectedState, "metadata", {}),
        dueTimePreference,
        isFixedStartTime: _.get(selectedState, "isFixedStartTime", false),
        timedTestDuration: _.get(selectedState, "timedTestDuration", {}),
        backDateCourses,
      });
      sendObj["courses"] = courses;

      isScheduledAssignment = isScheduled;

      if (!_.isEmpty(selectedState.folderNames)) {
        const folderNamesToSend = _.map(
          selectedState.folderNames,
          folderName => {
            return _.get(
              _.find(
                genericFoldersLocal,
                genericFolder => genericFolder.value == folderName
              ),
              "label",
              folderName
            );
          }
        );
        sendObj["folderNames"] = folderNamesToSend;
      }

      sendObj = update(sendObj, {
        resource: {
          attachments: {
            $set: _.map(
              _.get(selectedState, "resource.attachments", []),
              attachment =>
                _.omit(attachment, [
                  "id",
                  "__typename",
                  "streamUrl",
                  "signedUrl",
                  "isRead",
                  "questionAttachment",
                ])
            ),
          },
          studentTemplates: {
            $set: _.map(
              _.get(selectedState, "resource.studentTemplates", []),
              template => {
                return {
                  ...(_.omit(template, [
                    "id",
                    "__typename",
                    "isPost",
                    "attachmentId",
                    "streamUrl",
                    "isRead",
                    "questionAttachment",
                  ]) || {}),
                  attachments: _.map(
                    _.get(template, "attachments", []),
                    attachment =>
                      _.omit(attachment, [
                        "id",
                        "isRead",
                        "questionAttachment",
                        "signedUrl",
                      ])
                  ),
                };
              }
            ),
          },
          voiceInstruction: {
            $set: _.isEmpty(selectedState.resource.voiceInstruction)
              ? undefined
              : _.omit(selectedState.resource.voiceInstruction, [
                  "id",
                  "__typename",
                  "streamUrl",
                  "isRead",
                ]),
          },
        },
      });

      //omit unwanted meeting from sendObj, all necessary data has been added inside sendObj.resource.meeting
      sendObj = { ..._.omit(sendObj, ["meeting"]) };
      sendObj = update(sendObj, {
        curriculumProgramId: {
          $set: curriculumProgram.id,
        },
      });
    } else {
      const oldAttachments = _.get(assignmentData, "resource.attachments", []);
      const newAttachments = _.get(selectedState, "resource.attachments", []);
      const addedAttachments = _.differenceBy(
        newAttachments,
        oldAttachments,
        "id"
      );
      const removedAttachments = _.map(
        _.differenceBy(oldAttachments, newAttachments, "id"),
        attachment => attachment.id
      );

      const oldStudentTemplates = _.get(
        assignmentData,
        "resource.studentTemplates",
        []
      );

      const newStudentTemplates = _.get(
        selectedState,
        "resource.studentTemplates",
        []
      );

      const addedStudentTemplates = _.differenceBy(
        newStudentTemplates,
        oldStudentTemplates,
        "id"
      );

      const removedStudentTemplates = _.map(
        _.differenceBy(oldStudentTemplates, newStudentTemplates, "id"),
        template => template.id
      );

      if (!_.isEmpty(sendObj.resource)) {
        sendObj["resource"] = {
          ..._.omit(sendObj["resource"], [
            "attachments",
            "studentTemplates",
            "__typename",
          ]),
          addedStudentTemplates: _.map(addedStudentTemplates, template => {
            return {
              ...(_.omit(template, [
                "id",
                "__typename",
                "isPost",
                "attachmentId",
              ]) || {}),
              attachments: _.map(
                _.get(template, "attachments", []),
                attachment =>
                  _.omit(attachment, [
                    "id",
                    "streamUrl",
                    "isRead",
                    "questionAttachment",
                    "signedUrl",
                  ])
              ),
            };
          }),
          removedStudentTemplates,
          addedAttachments: _.map(addedAttachments, attachment =>
            _.omit(attachment, [
              "id",
              "__typename",
              "streamUrl",
              "isRead",
              "questionAttachment",
              "signedUrl",
            ])
          ),
          removedAttachments,
          voiceInstruction: {
            isAttachmentDeleted: _.isEmpty(
              _.get(sendObj, "resource.voiceInstruction", {})
            ),
            attachment: _.isEmpty(
              _.get(sendObj, "resource.voiceInstruction", {})
            )
              ? null
              : _.omit(_.get(sendObj, "resource.voiceInstruction", null), [
                  "id",
                  "__typename",
                  "streamUrl",
                  "isRead",
                ]),
          },
        };
      }

      sendObj = {
        id: assignmentData?.id,
        ...sendObj,
        ...getEditAssignmentMutationCoursesData({
          state,
          selectedState,
          assignmentData,
          genericFoldersLocal,
          dueTimePreference,
          backDateCourses,
        }),
      };
    }
    sendObj["creationSource"] = creationSource;
    sendObj["pageName"] = pageName;
    sendObj = _.omit(sendObj, ["isPrivate", "isLockSubmissionEnabled"]);

    const unitPlan = getUnitPlanFromAssessment({ assessmentDetails });

    if (
      mode === "create" &&
      !isToddleLibrary &&
      isLearningCoursesEnabled &&
      getIsAssignmentsUnitTaggingIn2_0Enabled() &&
      !_.isEmpty(unitPlan) &&
      sendObj.isIncludedInCourseFlow
    ) {
      await createCourseFlowResourceInsideUnit({
        unitPlanId: _.get(unitPlan, "id"),
        learningCourseId,
        assessmentId: _.get(assessmentDetails, "id", ""),
      });
    }

    const isPublishing = assessmentState === "PUBLISHED";
    const isFromClassMaterials = creationSource == "CLASS_MATERIALS";
    const showClassFlowConfirmationDialog =
      !_.isEmpty(classFlowConfirmationDialogData) && isPublishing;

    try {
      if (!isFromClassMaterials || !showClassFlowConfirmationDialog) {
        setIsLoading(true);
      }

      const titleField = _.find(assessmentDetails?.allFields, {
        uid: "title",
      });

      const { id, value } = titleField || {};

      const addToTopPreferenceValue = await getAddNewItemToTopPreference(
        userId
      );

      if (!_.isEmpty(value) && selectedState?.leId && _.trim(value) !== value) {
        updateAssessment({
          assessmentId: selectedState?.leId,
          fieldUID: "title",
          id,
          value: _.trim(value),
        });
      }

      let isSuccess = false;
      if (mode == "create") {
        const studentTemplateField = _.find(
          _.get(assessmentDetails, "allFields", []),
          {
            uid: "studentTemplate",
          }
        );
        const assessmentContainsWorkbook = _.some(
          _.get(
            studentTemplateField,
            "resolvedMinimalTree.attachmentGroups",
            []
          ),
          group =>
            _.some(_.get(group, "attachments", []), attachment =>
              _.isEqual(_.get(attachment, "type", ""), "WORKBOOK")
            )
        );
        isSuccess = await createAssignment({
          ...(sendObj || {}),
          portalType,
          isScheduledAssignment,
          state: assessmentState,
          isUnitDelinked: _.isEmpty(unitPlan),
          isDuplicateAssignment,
          putAfterItemId,
          assessmentContainsWorkbook,
          addToTop: addToTopPreferenceValue,
          hideSuccessToast,
          showDraftToast,
        });
        setMetaData({ submitted: true });
        refetchUpcomingEvents?.();

        const assignmentStateTabs = getAssignmentStateTabs();

        // switch to the respective tab in the classroom feed after assignment creation
        let key = null;
        if (assessmentState === "DRAFT") {
          key = assignmentStateTabs.DRAFT.value;
        } else if (isScheduledAssignment) {
          key = assignmentStateTabs.SCHEDULED.value;
        } else if (
          (!selectedState?.isStudentSubmissionEnabled &&
            !sendObj?.isTeacherEvaluationEnabled) ||
          getIsEnabledAssignmentImprovements()
        ) {
          key = assignmentStateTabs.ALL_POSTS.value;
        }

        if (key) {
          updateClassRoomFilters({
            assignmentStateTab: key,
            folderTopic: "ALL",
            status: "ALL",
            orderBy: _.get(assignmentStateTabs[key], "orderBy", ""),
          });
        }
      } else {
        const { isScheduled } = getAddedCoursesData({
          addedCourses: _.get(selectedState, "courses", []),
          dueTimePreference,
          isFixedStartTime: _.get(selectedState, "isFixedStartTime", false),
          timedTestDuration: _.get(selectedState, "timedTestDuration", {}),
        });
        if (isFromClassMaterials && showClassFlowConfirmationDialog) {
          setClassFlowConfirmationModalData({
            ...classFlowConfirmationDialogData,
            isOpen: true,
            isScheduled,
            onConfirm: async ({ value }) => {
              setIsLoading(true);
              if (value) {
                updateUserClassFlowSettings({
                  key: USER_CLASS_FLOW_SETTING_OPTIONS.ASSIGN_CONFIRMATION,
                  value: false,
                });
              }

              try {
                isSuccess = await updateAssignment({
                  ...(sendObj || {}),
                  isScheduledAssignment,
                  state: assessmentState,
                  creationSubSource,
                  assignmentContent,
                });
                refetchUpcomingEvents?.();
                setIsLoading(false);
                if (isSuccess) {
                  onClose({ isSuccess });
                }
              } catch (e) {
                console.error(e);
                setIsLoading(false);
              }
            },
            onClose: () => {
              setClassFlowConfirmationModalData({
                ...classFlowConfirmationDialogData,
                isOpen: false,
              });
            },
          });

          return;
        }
        isSuccess = await updateAssignment({
          ...(sendObj || {}),
          isScheduledAssignment,
          state: assessmentState,
          creationSubSource,
          assignmentContent,
          addToTop: addToTopPreferenceValue,
        });
        refetchUpcomingEvents?.();
      }
      setIsLoading(false);
      if (isSuccess) {
        onClose({ isSuccess });
      }
    } catch (e) {
      console.error(e);
      setIsLoading(false);
    }
  };

  const onCreateNewAssignment = async () => {
    if (!hideUnitSelection) return;

    setIsLoading(true);

    const selectedCourse = _.get(selectedState, "selectedCourse", {});

    // Only pass templateId if assessment type configuration is enabled
    const createAssessmentParams = {
      unitPlanObj: {
        unitPlanId: -1,
      },
      academicYears: _.map(
        _.get(selectedCourse, "academicYears", []),
        item => item.id
      ),
      assessmentType,
      groupType: taskTypeGroup,
      courseId: _.get(selectedCourse, "courseId", ""),
      primaryGradeId: _.get(selectedCourse, "primaryGrade.id", null),
    };

    // Only include templateId if assessment type configuration is enabled
    if (!_.isEmpty(assignmentTemplateId)) {
      createAssessmentParams.templateId = assignmentTemplateId;
    }

    if (!_.isEmpty(assignmentTaskTypeId)) {
      createAssessmentParams.taskTypeId = assignmentTaskTypeId;
    }

    const id = await createAssessment(createAssessmentParams);

    setIsLoading(false);

    updateSelectedItems({ leId: id });

    changeCurrentStep(
      steps.next({ current: currentStep, findKey: "value" }).value
    );
    setTimeout(() => updateCourses());
  };

  const onRetrieveAssignment = () => {
    const { assessmentData } = dialogBoxParams;

    updateSelectedItems(assessmentData);

    const initialStep = getInitialStep({
      creationMode,
      shouldCreateAssessment: false,
    });

    setCurrentStep(initialStep);
  };

  const changeStepWithValidation = value => {
    if (isNextDisabled) {
      setToastMsg("toastMsgs:please_select_atleast_one_item_error");
    } else {
      // using StepHeader user can jump from first step to last step directly
      // below code will stop user from doing that if user is skipping any step which is mandatory
      // and will redirect user to the mandatory step otherwise it will redirect user to the target step
      const currentStepIndex = _.findIndex(steps, { value: currentStep });
      const targetStepIndex = _.findIndex(steps, { value });

      const slicedSteps = _.slice(steps, currentStepIndex + 1, targetStepIndex);

      if (!_.isEmpty(slicedSteps)) {
        const step = getTargetStep({
          value,
          currentStep,
          steps: slicedSteps,
          isValid:
            isValid() &&
            isMaxScoreValid({
              assessmentDetails,
              isUsingNewGradingSetupInCourses,
              courseId:
                _.get(selectedState, "selectedCourse.courseId") || courseId,
            }),
          isWorksheetValid: assessmentDetailsRef?.isWorksheetValid?.(),
          assessmentDetailsRef,
        });

        changeCurrentStep(step);
      } else {
        changeCurrentStep(value);
      }
    }
  };

  const createNewWorksheet = async () => {
    const selectedCourse = _.get(selectedState, "selectedCourse", {});
    setIsLoading(true);
    const id = await createAssessment({
      unitPlanObj: { unitPlanId: -1 },
      academicYears: _.map(_.get(course, "academicYears", []), item =>
        _.get(item, "id")
      ),
      primaryGradeId: _.get(selectedCourse, "primaryGrade.id", null),
      selectedCurriculumProgramId: _.get(curriculumProgram, "id"),
      assessmentType: ASSESSMENT_TYPE_WORKSHEET,
      groupType: GROUP_TYPE_WORKSHEET,
    });
    setIsLoading(false);

    updateSelectedItems({ leId: id });
  };

  const handleClassSelectionStep = async () => {
    if (
      _.includes(
        [
          IMPORT_TODDLE_LIBRARY_WORKSHEET_IN_CLASS,
          CREATE_WORKSHEET,
          CREATE_WORKSHEET_FROM_TODDLE_LIBRARY,
        ],
        creationMode
      )
    ) {
      if (isToddleLibrary && isLearningCoursesEnabled) {
        if (!learningCourseId) {
          setToastMsg("toastMsgs:select_learning_course");
          return { moveToNextStep: false };
        }
      } else if (!courseId) {
        setToastMsg("toastMsgs:select_course");
        return { moveToNextStep: false };
      }
    }

    if (
      !selectedState.leId &&
      _.includes(
        [CREATE_WORKSHEET, CREATE_WORKSHEET_FROM_TODDLE_LIBRARY],
        creationMode
      )
    ) {
      await createNewWorksheet();
    }

    const isToddleLibrary2_0Import =
      isLearningCoursesEnabled &&
      isToddleLibrary &&
      creationMode === "ASSIGN_TO_COURSE";

    if (
      creationMode == IMPORT_TODDLE_LIBRARY_WORKSHEET_IN_CLASS ||
      isToddleLibrary2_0Import
    ) {
      const response = await createAssessmentClone();
      if (!response) {
        return { moveToNextStep: false };
      }
    }

    return { moveToNextStep: true };
  };

  const handleIsGeneratingAIResponse = isGenerating => {
    setIsGeneratingAIResponse(isGenerating);
  };

  const createAssessmentWithUnitPlan = async params => {
    const {
      value,
      assessmentType = ASSIGNMENT_TYPE_LE,
      groupType = LEARNING_ENGAGEMENT,
    } = params;

    let id = null;

    if (!selectedState.unitPlanId) {
      setToastMsg("toastMsgs:please_select_atleast_one_item_error");
      return;
    }

    if (!selectedState.leId) {
      setIsLoading(true);

      const unitPlanDetails = await getUnitPlanDetails({
        unitPlanId: selectedState.unitPlanId,
      });

      id = await createAssessment({
        unitPlanObj: {
          unitPlanId: selectedState.unitPlanId,
          unitPlanTemplateId: selectedState.unitPlanTemplateId,
        },
        academicYears: _.map(
          _.get(unitPlanDetails, "data.node.academicYears", []),
          "id"
        ),
        assessmentType,
        groupType,
      });

      setIsLoading(false);

      updateSelectedItems({ leId: id });
    }

    if (selectedState.leId || id) {
      changeStepWithValidation(value);
    }
  };

  const createAssessmentWithoutUnitPlan = async () => {
    const selectedCourse = _.get(selectedState, "selectedCourse", {});

    const {
      assessmentId,
      currentStep,
      assessmentData,
    } = await getAssessmentDataFromLocalStorage({
      creationMode,
      courseId: _.get(selectedCourse, "courseId", ""),
    });

    if (assessmentId) {
      setDialogBoxParams({
        key: creationMode,
        creationMode,
        assessmentId,
        currentStep,
        assessmentData,
      });

      return;
    }

    await onCreateNewAssignment();
  };

  const createAssessmentBasedOnLearningCourse = async () => {
    setIsLoading(true);

    const learningCourseSelectionState =
      selectedState?.learningCourseSelectionState || {};
    const selectedLearningCourse = _.get(
      learningCourseSelectionState,
      "selectedLearningCourse",
      {}
    );
    const selectedLearningCourseId = _.get(selectedLearningCourse, "id", "");

    const { importedLeId } = selectedState;
    const isAssignToClassFlow = creationMode === "ASSIGN_TO_COURSE";
    const isImportFlow = _.includes(
      [
        "IMPORT_LE_FROM_TODDLE_LIBRARY",
        "IMPORT_WORKSHEET_FROM_TODDLE_LIBRARY",
        "IMPORT_LE_FROM_LE_LIBRARY",
      ],
      creationMode
    );
    const shouldCreateAssessment = !isAssignToClassFlow && !isImportFlow;
    const shouldImportAssessment = isAssignToClassFlow;

    try {
      const [
        leId,
        { clonedAssessmentId, clonedAssessmentType } = {},
        filteredStaffCourses,
        learningCourseDetails,
      ] = await Promise.all([
        shouldCreateAssessment
          ? createAssessment({
              unitPlanObj: {
                unitPlanId: -1,
              },
              academicYears: _.map(
                _.get(selectedLearningCourse, "academicYears", []),
                item => item.id
              ),
              assessmentType,
              groupType: taskTypeGroup,
              learningCourseId: selectedLearningCourseId,
            })
          : undefined,
        shouldImportAssessment
          ? cloneAssessment({
              sourceAssessmentId: importedLeId,
              portalType,
              academicYears: _.map(
                _.get(selectedLearningCourse, "academicYears", []),
                item => item.id
              ),
              learningCourseId: selectedLearningCourseId,
              selectedCurriculumId: _.get(curriculumProgram, "id"),
            })
          : undefined,
        // Fetch staff classes of selected learning course in parallel
        getStaffCoursesBasicDetails({
          userId,
          portalType,
          academicYearId,
          userType,
          curriculumType,
          currentCurriculumProgramId: _.get(curriculumProgram, "id"),
          learningCourseId: selectedLearningCourseId,
          isDpPa: false,
          isDpEp: false,
        }),
        // Fetch all classes of selected learning course in parallel
        getLearningCourseDetails({
          learningCourseId: selectedLearningCourseId,
          portalType,
        }),
      ]);

      if (shouldCreateAssessment) {
        // Update the selected items with the created assessment ID
        updateSelectedItems({ leId });
      } else if (shouldImportAssessment) {
        setCurrentClonedImportedLeId(importedLeId);
        updateSelectedItems({ leId: clonedAssessmentId, clonedAssessmentType });
      }

      // Move to the next step in the workflow
      changeCurrentStep(
        steps.next({ current: currentStep, findKey: "value" }).value
      );

      updateCourses(filteredStaffCourses);
      setFilteredStaffCoursesIds(_.map(filteredStaffCourses, item => item.id));
      setLearningCourseClassIds(
        _.map(_.get(learningCourseDetails, "classes", []), item => item.id)
      );
    } catch (error) {
      setToastMsg("toastMsgs:something_went_wrong");
    } finally {
      setIsLoading(false);
    }
  };

  const cloneAssessmentWithImportLeId = async params => {
    const { value, shouldNotCloneAssessment = false } = params;

    if (!selectedState.importedLeId) {
      setToastMsg("toastMsgs:please_select_atleast_one_item_error");
      return;
    }

    if (shouldNotCloneAssessment) {
      updateSelectedItems({ leId: _.get(selectedState, "importedLeId", "") });
      changeStepWithValidation(value);
      return;
    }

    setIsLoading(true);

    const {
      clonedAssessmentId: leId,
      clonedAssessmentType,
    } = await cloneAssessment({
      sourceAssessmentId: _.get(selectedState, "importedLeId", ""),
      portalType,
      academicYears: courseAcademicYearsIds,
      learningCourseId,
    });

    setIsLoading(false);

    if (!_.isEmpty(leId)) {
      updateSelectedItems({ leId, clonedAssessmentType });
      changeStepWithValidation(value);
    } else {
      setToastMsg("toastMsgs:something_went_wrong");
    }
  };

  const createAssessmentFromCalendar = async () => {
    const emptyIdToCheck = hideUnitSelection
      ? _.get(selectedState, "selectedCourse.courseId", "")
      : _.get(selectedState, "unitPlanId", "");

    if (_.isEmpty(emptyIdToCheck)) {
      setToastMsg("toastMsgs:please_select_atleast_one_item_error");
      return;
    }

    const value = steps.next({ current: currentStep, findKey: "value" }).value;

    if (hideUnitSelection) {
      return await createAssessmentWithoutUnitPlan();
    } else if (creationMode !== IMPORT_LE) {
      return await createAssessmentWithUnitPlan({
        value,
        assessmentType,
        groupType: taskTypeGroup,
      });
    }

    if (selectedState.leId || creationMode === IMPORT_LE) {
      changeStepWithValidation(value);
    }
  };

  const onClickNext = async value => {
    const nextStep = steps.next({ current: currentStep, findKey: "value" });

    if (!value) {
      value = nextStep?.value;
    }

    // if user is navigation to prev step then do not validate the current step
    // just allow navigation to prev step
    const isNavigatingToPreviousStep = getIsNavigatingToPreviousStep({
      value,
      steps,
      currentStep,
    });

    if (isNavigatingToPreviousStep) {
      onClickPrevious();
      return;
    }

    switch (currentStep) {
      case DISCUSSION_CREATION: // deprecated (not being used right now)
        if (contentType == ASSIGNMENT_TYPE_ASSIGNMENT_RESOURCE) {
          if (_.isEmpty(_.get(selectedState, "resource.title", ""))) {
            setToastMsg("toastMsgs:please_enter_title_error");
            break;
          }
        }
        if (_.isEmpty(_.get(selectedState, "resource.label", ""))) {
          setToastMsg("toastMsgs:please_enter_prompt_message_error");
        } else {
          if (DiscussionPromptRef.isValid()) {
            setToastMsg("toastMsgs:please_enter_prompt_message_error");
          } else {
            changeCurrentStep(value);
          }
        }
        break;
      case LE_CREATE_UNIT_SELECTION:
        createAssessmentWithUnitPlan({ value });
        break;
      case WORKSHEET_UNIT_SELECTION:
        createAssessmentWithUnitPlan({
          value,
          assessmentType: ASSESSMENT_TYPE_WORKSHEET,
          groupType: GROUP_TYPE_WORKSHEET,
        });
        break;
      case SMT_CREATE_UNIT_SELECTION:
        createAssessmentWithUnitPlan({
          value,
          assessmentType: ASSIGNMENT_TYPE_SUMMATIVE,
          groupType: ASSESSMENT,
        });
        break;
      case FMT_CREATE_UNIT_SELECTION:
        createAssessmentWithUnitPlan({
          value,
          assessmentType: ASSIGNMENT_TYPE_FORMATIVE,
          groupType: ASSESSMENT,
        });
        break;
      case ASSESSMENT_CREATE_UNIT_SELECTION:
        createAssessmentWithUnitPlan({
          value,
          assessmentType: ASSIGNMENT_TYPE_PERFORMANCE_TASK,
          groupType: ASSESSMENT,
        });
        break;
      case SELECT_POST: // import from unit , LE selection step
      case TODDLE_LIBRARY_WORKSHEET_SELECTION:
        cloneAssessmentWithImportLeId({
          value,

          // In case of import from unit, if single assessment copy is enabled then
          // do not import assessment, assign same assessment in class
          shouldNotCloneAssessment:
            isSingleAssessmentCopy && currentStep === SELECT_POST,
        });
        break;
      case ASSESSMENT_DETAILS:
      case SMT_CREATION:
      case FMT_CREATION:
      case QT_CREATION:
      case LE_CREATION:
      case AI_TUTOR_CREATION:
      case ASSESSMENT_CREATION:
      case WORKSHEET_QUESTION_CREATION: {
        if (
          !isValid() ||
          !isMaxScoreValid({
            assessmentDetails,
            isUsingNewGradingSetupInCourses,
            courseId:
              _.get(selectedState, "selectedCourse.courseId") || courseId,
          })
        )
          return;
        changeStepWithValidation(value);
        break;
      }
      case UNIT_FROM_GRADE_SELECTION: {
        createAssessmentFromCalendar();
        break;
      }
      case LEARNING_COURSE_SELECTION: {
        createAssessmentBasedOnLearningCourse();
        break;
      }
      case QUESTION_CREATION: {
        if (!assessmentDetailsRef?.isWorksheetValid?.()) return;
        changeStepWithValidation(value);
        return;
      }
      case CLASS_SELECTION: {
        const { moveToNextStep } = await handleClassSelectionStep();
        if (!moveToNextStep) return;

        changeStepWithValidation(value);
        break;
      }
      default:
        changeStepWithValidation(value);
    }
  };

  const onClickPrevious = () => {
    const prevStep = steps.previous({ current: currentStep, findKey: "value" });
    changeCurrentStep(prevStep.value);
  };

  const shouldDeleteAssessmentClone = async () => {
    if (mode == "edit") return;

    const { importedLeId, leId, unitPlanId } = selectedState;

    if (leId) {
      if (
        importedLeId !== currentClonedImportedLeId ||
        unitPlanId !== prevUnitPlanId
      ) {
        await deleteAssessmentClone();
      } else return setIsLoading(false);
    }
  };

  const createAssessmentClone = async ({
    shouldNotCloneAssessment = false,
  } = {}) => {
    const { importedLeId, leId } = selectedState;

    if (
      !_.isEmpty(importedLeId) &&
      currentClonedImportedLeId == importedLeId &&
      !_.isEmpty(leId)
    ) {
      return true;
    }

    if (shouldNotCloneAssessment) {
      setCurrentClonedImportedLeId(importedLeId);
      setSelectedState(prev => ({
        ...prev,
        leId: importedLeId,
      }));
      return;
    }

    setIsLoading(true);

    shouldDeleteAssessmentClone();

    const { clonedAssessmentId, clonedAssessmentType } = await cloneAssessment({
      sourceAssessmentId: importedLeId,
      portalType,
      academicYears: courseAcademicYearsIds,
      selectedCourseId:
        !isToddleLibrary && isLearningCoursesEnabled ? courseId : null,
      selectedCurriculumId: _.get(curriculumProgram, "id"),
      learningCourseId,
    });

    setCurrentClonedImportedLeId(importedLeId);

    setSelectedState(prev => ({
      ...prev,
      leId: clonedAssessmentId,
      clonedAssessmentType,
    }));

    setIsLoading(false);

    return clonedAssessmentId;
  };

  const deleteAssessmentClone = async () => {
    if (!prevLeId) return;

    await deleteClonedAssessment({
      assessmentId: prevLeId,
      portalType,
    });
  };

  // this function will make sure that until user has selected the item in the screen the next button will be disabled
  // for example - in unit selection screen if unit is not selected then next button will be disabled
  const updateIsNextDisabled = () => {
    switch (currentStep) {
      case UNIT_SELECTION:
      case LE_CREATE_UNIT_SELECTION:
      case SMT_CREATE_UNIT_SELECTION:
      case FMT_CREATE_UNIT_SELECTION:
      case WORKSHEET_UNIT_SELECTION:
      case ASSESSMENT_CREATE_UNIT_SELECTION:
        setIsNextDisabled(_.isEmpty(_.get(selectedState, "unitPlanId", "")));
        break;
      case LE_SELECTION:
      case LE_LIBRARY_LE_SELECTION:
      case COMMUNITY_LE_SELECTION:
        setIsNextDisabled(_.isEmpty(_.get(selectedState, "importedLeId", "")));
        break;
      case ASSESSMENT_DETAILS:
      case WORKSHEET_QUESTION_CREATION:
        setIsNextDisabled(_.isEmpty(_.get(selectedState, "leId", "")));
        break;
      case UNIT_FROM_GRADE_SELECTION: {
        const emptyIdToCheck = hideUnitSelection
          ? _.get(selectedState, "selectedCourse.courseId", "")
          : _.get(selectedState, "unitPlanId", "");
        setIsNextDisabled(_.isEmpty(emptyIdToCheck));
        break;
      }
      case LEARNING_COURSE_SELECTION: {
        const learningCourseSelectionState =
          selectedState?.learningCourseSelectionState || {};
        setIsNextDisabled(
          _.isEmpty(learningCourseSelectionState?.selectedLearningCourse)
        );
        break;
      }
      case RESOURCE_SELECTION:
        setIsNextDisabled(
          _.isEmpty(_.get(selectedState, "resource.attachments", []))
        );
        break;
      case DISCUSSION_CREATION:
        setIsNextDisabled(uploadingStatus);
        break;
      default:
        setIsNextDisabled(false);
    }
  };

  const onClickDiscard = ({ shouldDeleteAssessment = true } = {}) => {
    const _assessmentMode = isCourseFlow ? assessmentMode : mode;

    switch (_assessmentMode) {
      case "create":
        if (!isSettingsStepOnly && !isToddleLibrary) {
          if (shouldUpdateAITabState) {
            updateAIDataInRedux({ aiTutorSelectedTab: "TASK_DETAILS" });
          }
          setCurrentDialogueAction("DISCARD"); // this will show a dialog box warning before closing
        } else {
          onClose({
            deleteClonedAssessment: shouldDeleteAssessment && !isCourseFlow,
            deleteCourseFlowResource: isCourseFlow,
          }); // in create mode when assessment is discarded delete its cloned copy
        }
        break;
      case "edit": {
        if (
          !isValid() ||
          !isMaxScoreValid({
            assessmentDetails,
            isUsingNewGradingSetupInCourses,
            courseId:
              _.get(selectedState, "selectedCourse.courseId") || courseId,
          })
        ) {
          if (shouldUpdateAITabState) {
            updateAIDataInRedux({ aiTutorSelectedTab: "TASK_DETAILS" });
          }

          return;
        }

        const isWorksheetAssessment =
          _.isEqual(assessmentType, ASSESSMENT_TYPE_WORKSHEET) || isWorksheet;
        if (!isWorksheetAssessment) {
          // if user discards the assignment after making changes in score or other assessment tools
          // then update the score, teacher and student evaluation status
          updateScoreAndEvaluation({ assessmentDetails, mode, assignmentId });
        }

        if (!_.isEqual(assignmentData, selectedState) && !isCourseFlow) {
          if (shouldUpdateAITabState) {
            updateAIDataInRedux({ aiTutorSelectedTab: "TASK_DETAILS" });
          }
          setCurrentDialogueAction("DISCARD");
        } else {
          onClose();
        }
      }
    }
  };

  const onDialogConfirmClick = () => {
    switch (currentDialogueAction) {
      case "DISCARD":
        removeAssessmentFromLocalStorage();
        onClose({
          deleteClonedAssessment: mode === "create" && !isCourseFlow,
          deleteCourseFlowResource: mode === "create" && isCourseFlow,
        });
    }
  };

  const onDialogWithAlertConfirmClick = () => {
    switch (currentDialogWithAlert) {
      case "UPDATE_AI_TUTOR": {
        onClickDone();
      }
    }
  };

  const onWorksheetDoneClick = useCallback(() => {
    if (mode === "create" || state === "DRAFT") {
      setShowSettingsModal(true);
    } else {
      onClickDone();
    }
  }, [mode, state]);

  const updateSelectedItems = useCallback(param => {
    setSelectedState(prev => {
      return {
        ...prev,
        ...param,
      };
    });
  }, []);

  const updateSelectedClassItems = useCallback(param => {
    setSelectedState(prev => ({
      ...prev,
      courses: _.map(prev?.courses, course => {
        if (_.isEqual(course?.id, param?.id)) {
          return {
            ...course,
            ...param,
          };
        }
        return course;
      }),
    }));
  }, []);

  const toggleWorksheetPreviewModal = useCallback(() => {
    setShowWorksheetPreviewModal(prev => {
      updateIsTeacherPreviewModeEnabled(!prev);
      return !prev;
    });
  }, []);

  const toggleDownloadWorksheetModal = useCallback(() => {
    setShowDownloadWorksheetModal(prev => !prev);
  }, []);

  const isLast = steps.last().value == currentStep;
  const isFirst = steps.first().value == currentStep;

  const isLessonPlanningEnabled = getIsLessonPlanningEnabled(
    assessmentType,
    taskTypeGroup
  );

  const isWorksheetQuestionsStep = currentStep == QUESTION_CREATION;

  const isPSOW = _.includes(EXCLUDED_ASSESSMENT_TYPES, assessmentType);

  const showAssistant =
    isLast &&
    isLessonPlanningEnabled &&
    showAssistantRightPane &&
    !isSettingsStepOnly &&
    !isToddleLibrary &&
    !isPSOW;

  const showWorksheetAssistant =
    showAssistantRightPane && isWorksheetQuestionsStep && !isToddleLibrary;

  const showHeader = !resourceSelection && (!isSettingsStepOnly || isWorksheet);
  const showStepHeader = _.size(steps) > 1 && !resourceSelection;

  const parentId = _.get(selectedState, "leId");

  const showCompactUIFooter = isAITutor || isWorksheetCreateEditMode;

  const hideFooter =
    _.isNil(assessmentType) && _.isEqual(ASSESSMENT_DETAILS, currentStep);

  const currentStepNotAssessmentDetail = _.size(steps) > 1 && isFirst;

  // classes

  const containerWrapperClass = classNames({
    [classes.container]: true,
    [classes.flexDirectionRow]:
      isLessonPlanningEnabled || showWorksheetAssistant,
    [classes.containerWrapperWithChat]: showAssistant || showWorksheetAssistant,
  });

  const transparentModalClass = classNames({
    [classes.transparentModal]: isSettingsStepOnly,
  });

  const checkIsDueDateBeforeScheduleDate = () => {
    const courses = _.get(selectedState, "courses", []);

    return _.some(courses, course => {
      const {
        state: { scheduleDate, scheduleTime } = {},
        deadlineDate,
        deadlineTime,
      } = course;

      const scheduleString = generateDateTimeString({
        dateString: scheduleDate,
        timeString: scheduleTime,
      });

      const deadlineString = generateDateTimeString({
        dateString: deadlineDate,
        timeString: deadlineTime,
      });

      const scheduledDateObj = !_.isEmpty(scheduleString)
        ? moment(scheduleString, "YYYY-MM-DD:HH:mm", true).isValid()
          ? moment(scheduleString, "YYYY-MM-DD:HH:mm").toISOString()
          : moment(scheduleString, "YYYY-MM-DD").toISOString()
        : mode === "create" || state === "DRAFT"
        ? moment().toISOString()
        : null;

      const dueTime = !_.isEmpty(dueTimePreference)
        ? dueTimePreference
        : "09:00";
      const deadlineDateObj = !_.isEmpty(deadlineString)
        ? moment(deadlineString, "YYYY-MM-DD:HH:mm", true).isValid()
          ? moment(deadlineString, "YYYY-MM-DD:HH:mm").toISOString()
          : moment(
              `${deadlineString}:${dueTime}`,
              "YYYY-MM-DD:HH:mm"
            ).toISOString()
        : null;

      if (!_.isEmpty(scheduledDateObj) && !_.isEmpty(deadlineDateObj)) {
        return checkIsDateBefore({
          date1: deadlineDateObj,
          date2: scheduledDateObj,
          key: "minutes",
        });
      }

      return false;
    });
  };

  const toggleErrorModal = useCallback(({ isAssignClicked = true } = {}) => {
    setErrorModalParams(prev => ({
      showErrorModal: !prev?.showErrorModal,
      isAssignClicked,
    }));
  }, []);

  const onCloseBackDateModal = useCallback(() => {
    setBackDateModalParams({});
  }, []);

  const getBackDateModalBodyMsgV2 = () => {
    let backDateCoursesToDisplay = backDateCourses;

    let bodyText = "classRoom:open_date_in_past_body_message";

    if (hasBothOpenAndDueDateBackdated) {
      backDateCoursesToDisplay = _.filter(backDateCourses, course =>
        _.get(course, "isBackdateAssignment", false)
      );
      bodyText = "classRoom:open_and_due_date_in_past_body_message_v2";
    }

    const classTitlesArr = _.map(
      backDateCoursesToDisplay,
      course => `'${_.get(course, "title", "")}'`
    );
    const classes = joinWithCommaAnd({ data: classTitlesArr, t });

    return <span>{t(bodyText, { classes })}</span>;
  };

  const handleBackDateModalOnClickDone = () => {
    const { onClickDoneParams = {} } = backDateModalParams;
    if (hasBothOpenAndDueDateBackdated) {
      onClickDoneParams["backDateCourses"] = _.filter(backDateCourses, course =>
        _.get(course, "isBackdateAssignment", false)
      );
    }

    onClickDone(onClickDoneParams);
  };

  const getBackDateModalButtonTwoText = () => {
    const courses = _.get(selectedState, "courses", []);

    const buttonLabelText = _.get(backDateModalParams, "buttonLabelText", "");

    if (
      _.size(backDateCourses) === _.size(courses) &&
      buttonLabelText === t("common:schedule")
    ) {
      return t("classRoom:yes_with_action_in_lowercase", {
        action: t("common:assign"),
      });
    } else {
      return t("classRoom:yes_with_action_in_lowercase", {
        action: buttonLabelText,
      });
    }
  };

  const assessmentTypes = getCurrentAssessmentTypes();
  const assessmentTypeId = _.get(assessmentDetails, "assessmentType.value");
  const { localeLabel, label: nonLocalisedLabel } =
    _.get(assessmentTypes, assessmentTypeId) || {};
  const assessmentTypeLabel = localeLabel ? t(localeLabel) : nonLocalisedLabel;

  const DIALOGUES_INFO = getDialogInfo({
    assessmentTypeLabel,
    assessmentTitle,
  });

  const onCloseCurrentActionDialog = () => {
    setCurrentDialogueAction("");
  };

  const renderErrorModal = () => {
    const isAssignClicked = _.get(errorModalParams, "isAssignClicked", true);

    return (
      <Modal width={"440px"} height={"max-content"} onClose={toggleErrorModal}>
        <Modal.Header isClosable={true}>
          <div className={classes.errorModalHeader}>
            {t("classRoom:error_due_date_before_schedule_date")}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className={classes.errorModalMessage}>
            {isAssignClicked
              ? t("classRoom:due_date_before_schedule_date_message_on_assign")
              : t("classRoom:due_date_before_schedule_date_message_on_draft")}
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  const renderBackDateModal = () => {
    return (
      <Dialog
        dsVersion="2.0"
        variant="delete-dialog"
        title={
          hasBothOpenAndDueDateBackdated
            ? t("classRoom:due_date_is_in_the_past")
            : t("classRoom:open_date_is_in_the_past")
        }
        message={<span>{getBackDateModalBodyMsgV2()}</span>}
        buttonOneText={
          hasBothOpenAndDueDateBackdated
            ? t("common:cancel")
            : t("classRoom:back_date_modal_keep_editing_label")
        }
        buttonTwoText={getBackDateModalButtonTwoText()}
        onButtonOneClick={onCloseBackDateModal}
        onButtonTwoClick={handleBackDateModalOnClickDone}
        onClose={onCloseBackDateModal}
      />
    );
  };

  const renderFooter = () => {
    const showFooterButtonsWithSpace =
      currentStep === "LE_LIBRARY_LE_SELECTION";

    return !isSettingsStepOnly ? (
      <CompactUIFooter
        mode={mode}
        state={state}
        isFirstStep={isFirst}
        isLastStep={isLast}
        isValid={isValid}
        onClickDone={onClickDone}
        onClickCancel={onClickDiscard}
        onClickNext={onClickNext}
        onClickPrevious={onClickPrevious}
        onResourceSelectionDone={onResourceSelectionDone}
        setShowSettingsModal={setShowSettingsModal}
        customFooterButton={customFooterButton}
        assessmentId={selectedState.leId}
        isNextDisabled={isNextDisabled}
        resourceSelection={resourceSelection}
        toggleErrorModal={toggleErrorModal}
        setBackDateModalParams={setBackDateModalParams}
        courses={_.get(selectedState, "courses", [])}
        checkIsDueDateBeforeScheduleDate={checkIsDueDateBeforeScheduleDate}
        currentDialogueAction={currentDialogueAction}
        assessmentType={assessmentType}
        taskTypeGroup={taskTypeGroup}
        setCurrentDialogWithAlert={setCurrentDialogWithAlert}
        assignmentId={assignmentId}
        setIsLoading={setIsLoading}
        parentId={parentId}
        parentType={ASSESSMENT}
        portalType={portalType}
        isWorksheetCreationStep={isWorksheetCreationStep}
        {...(showFooterButtonsWithSpace ? footerButtonsWithSpaceStyle : {})}
        assignmentLevelPreferences={_.get(
          selectedState,
          "metadata.preferences",
          []
        )}
        assignmentData={assignmentData}
        isUsingNewGradingSetupInCourses={isUsingNewGradingSetupInCourses}
        courseId={_.get(selectedState, "selectedCourse.courseId") || courseId}
      />
    ) : null;
  };

  return (
    <ConditionalWrapper
      type={"wrapperAsElement"}
      condition={showInModal}
      wrapper={
        <UIModal
          isOpen={true}
          isFullScreen={true}
          modalContent={transparentModalClass}
          overlayContainer={transparentModalClass}
        />
      }
    >
      <div className={containerWrapperClass}>
        <div className={classes.container}>
          {/* Header  */}
          {showHeader ? (
            <Header
              onClickBack={onClickDiscard}
              mode={mode}
              createHeader={createHeader}
              editHeaderText={editHeaderText}
              showImageTitleInHeader={showImageTitleInHeader}
              assignmentDetails={assignmentDetails}
              currentStep={currentStep}
              isLastStep={isLast}
              isWorksheetQuestionsStep={isWorksheetQuestionsStep}
              toggleWorksheetPreviewModal={toggleWorksheetPreviewModal}
              setShowAssistantRightPane={setShowAssistantRightPane}
              isLessonPlanningEnabled={isLessonPlanningEnabled}
              assessmentType={assessmentType}
              taskTypeGroup={taskTypeGroup}
              curriculumType={curriculumType}
              contentType={contentType}
              toggleDownloadWorksheetModal={toggleDownloadWorksheetModal}
              isToddleLibrary={isToddleLibrary}
              parentId={parentId}
              creationMode={creationMode}
              isWorksheetCreationStep={isWorksheetCreationStep}
              isPSOW={isPSOW}
              testId={testId}
              assessmentId={_.get(selectedState, "leId", "")}
              academicYearId={academicYearId}
              showAssessmentLockIcon={showAssessmentLockIcon}
              isLocked={isLocked}
              hasConflict={hasConflict}
              syncStatus={syncStatus}
              dynamicAssessmentIcon={dynamicAssessmentIcon}
              isGeneratingAIResponse={isGeneratingAIResponse}
              showCommentIcon={isLearningCoursesEnabled && isUnitRoute}
              onCommentClick={handleCommentClick}
              isCommentActive={isCommentPaneActive}
              totalCommentCount={commentCounts.totalCommentCount}
              unreadCommentCount={commentCounts.unreadCommentCount}
            >
              {showCompactUIFooter ? renderFooter() : null}
            </Header>
          ) : null}

          <div className={containerWrapperClass}>
            <div className={classes.container}>
              {/* Step Header */}
              {showStepHeader ? (
                <StepHeader
                  steps={steps}
                  currentStep={currentStep}
                  onClickStep={onClickNext}
                  testId={testId}
                />
              ) : null}

              {/* Step Container */}
              {!isSettingsStepOnly ? (
                <StepContainer
                  resourceSelection={resourceSelection}
                  mode={mode}
                  courseId={
                    _.get(selectedState, "selectedCourse.courseId") || courseId
                  }
                  courseList={courseList}
                  curriculumProgram={curriculumProgram}
                  changeSelectedState={setSelectedState}
                  selectedState={selectedState}
                  contentType={contentType}
                  currentStep={currentStep}
                  currentStepObj={_.find(steps, { value: currentStep })}
                  getDiscussionPromptRef={getDiscussionPromptRef}
                  setAssessmentDetailsRef={setAssessmentDetailsRef}
                  setWorksheetRef={setWorksheetRef}
                  setUploadingStatus={setUploadingStatus}
                  updateCourseId={updateCourseId}
                  portalType={portalType}
                  selectedTimeSlot={selectedTimeSlot}
                  assignmentId={assignmentId}
                  creationMode={creationMode}
                  updateUnitPlanDataInRedux={updateUnitPlanDataInRedux}
                  grades={grades}
                  subjects={subjects}
                  courseSubjects={
                    !_.isEmpty(courseSubjects)
                      ? courseSubjects
                      : _.get(selectedState, "selectedCourse.subjects", [])
                  }
                  creationSource={creationSource}
                  pageName={pageName}
                  isFromUnitPlan={isFromUnitPlan}
                  setDialogBoxParams={setDialogBoxParams}
                  onWorksheetDoneClick={onWorksheetDoneClick}
                  updateSelectedItems={updateSelectedItems}
                  defaultQuestionIds={defaultQuestionIds}
                  setCurrentClonedImportedLeId={setCurrentClonedImportedLeId}
                  showWorksheetAssistant={showWorksheetAssistant}
                  isDraft={state === "DRAFT"}
                  assessmentType={assessmentType}
                  testId={testId}
                  setIsAssessmentFetched={setIsAssessmentFetched}
                  learningCourseId={learningCourseId}
                  primaryGradeId={primaryGradeId}
                  handleIsGeneratingAIResponse={handleIsGeneratingAIResponse}
                  onCommentActiveChange={handleCommentActiveChange}
                  onCommentCountsChange={handleCommentCountsChange}
                />
              ) : null}

              {/* Footer */}
              {!hideFooter && !showCompactUIFooter ? renderFooter() : null}
            </div>

            {/* AI Chat */}
            {!isSettingsStepOnly ? (
              <Transition
                isOpen={showAssistant}
                {...LESSON_PLANNING_TRANSITION_PROPS}
              >
                <DSProvider dsVersion="2.0">
                  <LessonPlanningAssistant
                    portalType={portalType}
                    sourceFrom={creationSource}
                    leId={selectedState.leId}
                    setShowAssistantRightPane={setShowAssistantRightPane}
                    mode={mode}
                    courseId={courseId}
                    selectedCourse={_.get(selectedState, "selectedCourse", {})}
                    middlePaneRef={assessmentDetailsRef?.step?.middlePane}
                    unitPlanId={selectedState.unitPlanId}
                    isFromUnitPlan={isFromUnitPlan}
                    creationMode={creationMode}
                    isDraft={state === "DRAFT"}
                    testId={"assessment-addAssignment"}
                    learningCourseId={learningCourseId}
                  />
                </DSProvider>
              </Transition>
            ) : null}

            {/* Worksheet AI Chat */}
            {showWorksheetAssistant ? (
              <Transition
                isOpen={showWorksheetAssistant}
                {...LESSON_PLANNING_TRANSITION_PROPS}
              >
                <AiQuestionAssistant
                  setAssessmentFullScreenLoader={setIsLoading}
                  portalType={portalType}
                  sourceFrom={creationSource}
                  leId={_.get(selectedState, "leId")}
                  setShowAssistantRightPane={setShowAssistantRightPane}
                  mode={mode}
                  courseId={courseId}
                  selectedCourse={_.get(selectedState, "selectedCourse", {})}
                  middlePaneRef={assessmentDetailsRef?.step?.middlePane}
                  unitPlanId={selectedState.unitPlanId}
                  isFromUnitPlan={isFromUnitPlan}
                  creationMode={creationMode}
                  isDraft={state === "DRAFT"}
                />
              </Transition>
            ) : null}
          </div>

          {/* Assignment settings modal */}
          {showSettingsModal ? (
            <AssignmentSettings
              curriculumType={curriculumType}
              curriculumProgram={curriculumProgram}
              isClassDiscussionEnabled={_.get(
                selectedState,
                "isClassDiscussionEnabled",
                false
              )}
              isStudentSubmissionEnabled={_.get(
                selectedState,
                "isStudentSubmissionEnabled",
                false
              )}
              isPrivate={_.get(selectedState, "isPrivate", false)}
              isExcludedFromFinalGradeCalculation={_.get(
                selectedState,
                "isExcludedFromFinalGradeCalculation",
                false
              )}
              isOnScreenCalculatorEnabled={_.get(
                selectedState,
                "isOnScreenCalculatorEnabled",
                false
              )}
              showStudentResponse={_.get(
                selectedState,
                "showStudentResponse",
                "ONCE_EVALUATED"
              )}
              courses={_.get(selectedState, "courses", [])}
              folderNames={_.get(selectedState, "folderNames", [])}
              courseId={
                isToddleLibrary && isLearningCoursesEnabled
                  ? null
                  : _.get(selectedState, "selectedCourse.courseId") || courseId
              }
              contentType={selectedState.contentType}
              leId={selectedState.leId}
              updateSelectedItems={updateSelectedItems}
              portalType={portalType}
              studentTemplates={_.get(
                selectedState,
                "resource.studentTemplates",
                []
              )}
              selectedTimeSlot={selectedTimeSlot}
              mode={mode}
              assignmentId={assignmentId}
              isSimilarityCheckEnabled={selectedState.isSimilarityCheckEnabled}
              sourceFrom={creationSource}
              grades={grades}
              subjects={subjects}
              toggleSettingsModal={() => {
                setShowSettingsModal(prevState => !prevState);
                if (isSettingsStepOnly) {
                  isFromUnitPlan
                    ? onClickDiscard({
                        shouldDeleteAssessment: !ACLStore.can(
                          "FeatureFlag:SingleAssessmentCopy"
                        ),
                      })
                    : onClose();
                }
              }}
              onClickDone={onClickDone}
              state={state}
              isSettingsStepOnly={isSettingsStepOnly}
              isFromUnitPlan={isFromUnitPlan}
              isTimedTestEnabled={_.get(
                selectedState,
                "isTimedTestEnabled",
                false
              )}
              isFixedStartTime={_.get(selectedState, "isFixedStartTime", false)}
              isLockScreenEnabled={_.get(
                selectedState,
                "isLockScreenEnabled",
                false
              )}
              isSafeBrowserEnabled={_.get(
                selectedState,
                "isSafeBrowserEnabled",
                false
              )}
              timedTestDuration={_.get(selectedState, "timedTestDuration", {})}
              assignmentData={assignmentData}
              isLockSubmissionEnabled={_.get(
                selectedState,
                "isLockSubmissionEnabled",
                false
              )}
              isSharedWithClassMaterial={_.get(
                selectedState,
                "isSharedWithClassMaterial",
                false
              )}
              isDuplicateAssignment={isDuplicateAssignment}
              toggleErrorModal={toggleErrorModal}
              setBackDateModalParams={setBackDateModalParams}
              setCurrentDialogWithAlert={setCurrentDialogWithAlert}
              checkIsDueDateBeforeScheduleDate={
                checkIsDueDateBeforeScheduleDate
              }
              assignedStudents={assignedStudents}
              testId={testId}
              createdAt={createdAt}
              isAITutor={isAITutor}
              sourceAssignmentId={sourceAssignmentId}
              metadata={metadata}
              dueTimePreference={dueTimePreference}
              assignmentLevelPreferences={_.get(
                selectedState,
                "metadata.preferences",
                []
              )}
              filteredStaffCoursesIds={filteredStaffCoursesIds}
              learningCourseId={learningCourseId}
              learningCourseClassIds={learningCourseClassIds}
              isIncludedInCourseFlow={_.get(
                selectedState,
                "isIncludedInCourseFlow",
                false
              )}
              isCourseFlow={isCourseFlow}
              updateSelectedClassItems={updateSelectedClassItems}
              assignmentDefaultSettings={assignmentDefaultSettings}
              isSendAssignedNotification={_.get(
                selectedState,
                "isSendAssignedNotification",
                true
              )}
              primaryGradeId={primaryGradeId}
              taskTypeGroup={taskTypeGroup}
            />
          ) : null}

          {/* Worksheet preview modal */}
          {showWorksheetPreviewModal ? (
            <UIModal isOpen={true} isFullScreen={true}>
              <Worksheet
                mode={MODE_TEACHER_PREVIEW}
                parentId={parentId}
                parentType={ASSESSMENT}
                toggleWorksheetModal={toggleWorksheetPreviewModal}
                assignmentId={assignmentId}
                portalType={PLANNER}
              />
            </UIModal>
          ) : null}

          {/* Worksheet download modal */}

          {showDownloadWorksheetModal ? (
            <DownloadWorksheetModal
              t={t}
              toggleDownloadWorksheetModal={toggleDownloadWorksheetModal}
              parentId={parentId}
              assignmentId={assignmentId}
              parentType={ASSESSMENT}
              portalType={PLANNER}
              templateId={_.get(assessmentDetails, "templateId", "")}
            />
          ) : null}

          {/* Modal to show when user has a unsaved assignment in the local storage */}
          {!_.isEmpty(dialogBoxParams) ? (
            <AssessmentDraftModal
              onClose={() => setDialogBoxParams({})}
              onCreateNewAssignment={onCreateNewAssignment}
              onRetrieveAssignment={onRetrieveAssignment}
              courseId={
                courseId || _.get(selectedState, "selectedCourse.courseId")
              }
              {...dialogBoxParams}
            />
          ) : null}

          {/* Dialog  */}
          {!_.isEmpty(currentDialogueAction) ? (
            <Dialog
              isOpen={true}
              variant={"delete-dialog"}
              dsVersion={"2.0"}
              title={DIALOGUES_INFO[currentDialogueAction].title(t)}
              message={DIALOGUES_INFO[currentDialogueAction].message(t)}
              onButtonTwoClick={onDialogConfirmClick}
              onButtonOneClick={
                currentStepNotAssessmentDetail
                  ? onCloseCurrentActionDialog
                  : handleSaveAsDraft
              }
              onClose={onCloseCurrentActionDialog}
              testId={testId}
              buttonOneText={
                currentStepNotAssessmentDetail
                  ? t("common:cancel")
                  : DIALOGUES_INFO[currentDialogueAction].cancelButtonText(t)
              }
              buttonTwoText={DIALOGUES_INFO[
                currentDialogueAction
              ].confirmButtonText(t)}
            />
          ) : null}

          {/* Modal with Alert */}
          <Modal
            isOpen={!_.isEmpty(currentDialogWithAlert)}
            onClose={() => setCurrentDialogWithAlert("")}
            width={DIALOGUES_INFO?.[currentDialogWithAlert]?.width || "440px"}
            height={"fit-content"}
            zIndex={1111}
            dsVersion={"2.0"}
          >
            <Modal.Header
              title={DIALOGUES_INFO?.[currentDialogWithAlert]?.title(t)}
              isClosable={true}
              style={styles.modalHeaderStyle}
            />

            <Modal.Body style={styles.modalBodyStyle}>
              <div className={classes.modalBody}>
                <div className={"text-body"}>
                  {DIALOGUES_INFO?.[currentDialogWithAlert]?.message(t)}
                </div>

                <Alert
                  type="warning"
                  showIcon={true}
                  message={DIALOGUES_INFO?.[currentDialogWithAlert]?.alertText(
                    t
                  )}
                />
              </div>
            </Modal.Body>

            <Modal.Footer style={styles.modalFooterStyle}>
              <footer className={classes.modalFooter}>
                <Button
                  dsVersion={"2.0"}
                  variant={"neutral"}
                  type={"outlined"}
                  size={"medium"}
                  onClick={() => setCurrentDialogWithAlert("")}
                >
                  {DIALOGUES_INFO?.[currentDialogWithAlert]?.cancelButtonText(
                    t
                  )}
                </Button>

                <Button
                  dsVersion={"2.0"}
                  variant={"destructive"}
                  type={"fill"}
                  size={"medium"}
                  onClick={onDialogWithAlertConfirmClick}
                >
                  {DIALOGUES_INFO?.[currentDialogWithAlert]?.confirmButtonText(
                    t
                  )}
                </Button>
              </footer>
            </Modal.Footer>
          </Modal>

          {!_.isEmpty(backDateModalParams) ? renderBackDateModal() : null}

          {_.get(errorModalParams, "showErrorModal", false)
            ? renderErrorModal()
            : null}

          {/* Loader */}
          {isLoading ? (
            <FullScreenLoader overlayContainer={classes.overlayContainer} />
          ) : null}
        </div>
      </div>
    </ConditionalWrapper>
  );
});

AddAssignment.displayName = "AddAssignment";

const EMPTY_OBJECT = {};

const mapStateToProps = (state, ownProps) => {
  const selectedCurriculumId = getSelectedCurriculumId(state);
  const curriculumProgramVariant = _.get(
    getSelectedCurriculumProgram(state),
    "variant"
  );
  const userName = getUserName(state);
  const isToddleLibrary = state.login.activeTab == "TODDLE_LIBRARY";
  const isLtiAttachmentDeleted = _.get(
    state,
    "assessment.isLtiAttachmentDeleted",
    false
  );
  // When assigning LE to students (from Toddle Library portal), curriculum context is set based on the class selected
  const curriculumProgramFromClassRoomState = _.get(
    state,
    "classRoom.curriculumProgram"
  );
  const currentCurriculumProgram = !_.isEmpty(
    curriculumProgramFromClassRoomState
  )
    ? curriculumProgramFromClassRoomState
    : getSelectedCurriculumProgram(state);

  const isGlobalHeaderVisible = _.get(
    state,
    "login.globalHeader.isVisible",
    false
  );

  const classFlowConfirmationDialogData = _.get(
    state,
    "classMaterials.confirmationDialogData",
    {}
  );

  const academicYearId = getSelectedAcademicYearId(state);

  const isGeneratingAIQuestions = _.get(
    state,
    "worksheet.generatingAIQuestions",
    false
  );

  const courseFlowResourceData = _.get(
    state,
    "classRoom.courseFlowResourceData",
    EMPTY_OBJECT
  );

  const selectedCourseId = _.get(state, "classRoom.selectedCourseId");

  const isToddleLibrary2_0 = isToddleLibrary && getIsLearningCoursesEnabled();

  const aiTutorSelectedTab = _.get(
    state,
    "assessment.aiData.aiTutorSelectedTab"
  );

  const plannerAssignmentModalData = _.get(
    state,
    "classPlanner.assignmentModalData",
    null
  );

  return {
    selectedCurriculumId,
    currentCurriculumProgram,
    academicYearId,
    isCommunity: _.get(state, "login.activeTab") === "community",
    isToddleLibrary,
    selectedCourseId,
    userName,
    curriculumProgramVariant,
    isGlobalHeaderVisible,
    classFlowConfirmationDialogData,
    isGeneratingAIQuestions,
    plannerAssignmentModalData,
    isLtiAttachmentDeleted,
    // TODO: learningCourseId should come from props or some other redux state for...
    // toddle library, school library, homepage calendar, assignments manager (anything outside learning-course route)
    learningCourseId:
      _.get(ownProps, "learningCourseId") ||
      _.get(state, "planner.unitPlanData.learningCourseId", null) ||
      getSelectedLearningCourseId(state),
    courseFlowResourceData,
    primaryGradeId: getIsLearningCoursesEnabled()
      ? _.get(state, "learningCourse.selectedLearningCourse.primaryGradeId")
      : _.get(state, "teacher.selected_class.primaryGrade.id"),
    isToddleLibrary2_0,
    aiTutorSelectedTab,
  };
};

const getDerivedProps = ownProps => {
  const {
    steps,
    grades,
    course,
    isWorksheet,
    courseList,
    portalType,
    isFromUnitPlan,
    preSelectedCourseIds,
    academicYearId,
    isToddleLibrary,
    selectedCourseId,
    currentCurriculumProgram,
    selectedCurriculumId,
    creationSource,
  } = ownProps;

  const userInfo = getUserInfo({ portalType }) || {};

  const platformUserInfo = getUserInfo({ portalType: "PLANNER" });
  const platformUserId = _.get(platformUserInfo, "id");

  const isSchoolLibrary = isSchoolLibraryRoute();

  const organizationId = userInfo.org_id;

  const isCourseFlow = creationSource === "COURSE_FLOW";
  const isClassPlanner = creationSource === "CLASS_PLANNER";

  const curriculumProgram =
    isToddleLibrary || isSchoolLibrary || isCourseFlow
      ? currentCurriculumProgram
      : _.get(course, "curriculumProgram", currentCurriculumProgram);
  const currentCurriculumProgramId =
    _.get(curriculumProgram, "id") || selectedCurriculumId;

  const { startDate, endDate } =
    getCurrentAcademicYear({ organizationId }) || {};

  const showCalendarAssignmentByDueDate =
    getCalendarEventsViewSettingValue({
      organizationId,
      currentCurriculumProgramId,
    }) === MY_CALENDAR_CONSTANTS.DUE_DATE;

  const curriculumType = _.get(curriculumProgram, "type");

  const collaboratorsFilter = {
    userAcademicYearId: academicYearId,
  };

  const dueTimePreference = getSettingValue({
    name: "AssignmentDueTimePreference",
    userId: userInfo?.id,
    organizationId,
    currentCurriculumProgramId,
  });

  const assignmentDefaultSettings = getSettingValue({
    name: "AssignFlowDefaultSettings",
    userId: userInfo?.id,
    organizationId,
    currentCurriculumProgramId,
  });

  const sendAssignNotificationPreference = getSettingValue({
    name: "SendAssignNotificationPreference",
    readFromUserAndOrgLevel: true,
  });

  const isUsingNewGradingSetupInCourses = getIsConfigurationEnabledForCPAY({
    configuration: USE_NEW_GRADING_SETUP_IN_COURSE_PERM,
    curriculumProgramId: currentCurriculumProgramId,
    academicYearId: academicYearId,
  });

  return {
    isData: true,
    isLoading: false,
    userId: userInfo.id,
    course,
    endDate,
    startDate,
    curriculumType,
    platformUserId,
    isSchoolLibrary,
    curriculumProgram,
    collaboratorsFilter,
    dueTimePreference,
    ...getStepsInfo({ steps, isFromUnitPlan, isWorksheet }),
    courseId: ownProps.courseId || selectedCourseId,
    grades: !_.isEmpty(grades) ? grades : _.get(course, "grades", []),
    preSelectedCourseIds: getPreselectedCourseIds({
      steps,
      preSelectedCourseIds,
      courseList,
    }),
    courseAcademicYearsIds: getCourseAcademicYearsIds({ course }),
    showCalendarAssignmentByDueDate,
    userType: userInfo?.user_type,
    isLearningCoursesEnabled: getIsLearningCoursesEnabled(),
    isCourseFlow,
    isClassPlanner,
    currentCurriculumProgramId,
    isUsingNewGradingSetupInCourses,
    assignmentDefaultSettings,
    sendAssignNotificationPreference,
  };
};

const mapActionCreators = {
  createAssignment,
  setToastMsg,
  updateAssignment,
  cloneAssessment,
  updateCourseId,
  deleteClonedAssessment,
  createAssessment,
  getUnitPlanDetails,
  setCourseId,
  updateAssessmentInCache,
  getAssessmentDataFromLocalStorage,
  isMaxScoreValid,
  getSimilarityIndexDefaultValue,
  updateScoreAndEvaluation,
  enableGlobalHeader,
  disableGlobalHeader,
  updateAIDataInRedux,
  setClassFlowConfirmationModalData,
  updateUserClassFlowSettings,
  updateIsTeacherPreviewModeEnabled,
  updateAssessment,
  updateClassRoomFilters,
  getStaffCoursesBasicDetails,
  getLearningCourseDetails,
  setCourseFlowResourceDataForRefetch,
  deleteCourseFlowResources,
  deleteAssessment,
  getCurrentAssessmentTypes,
  createCourseFlowResources,
  createCourseFlowResourceInsideUnit,
  updateTimetableSlotItems,
  updateWeeklyPlannerSectionItems,
};

AddAssignment.displayName = "AddAssignment";

AddAssignment.propTypes = {
  resourceSelection: PropTypes.bool,
  showInModal: PropTypes.bool,
  isFromUnitPlan: PropTypes.bool,
  isUnitRoute: PropTypes.bool,
  isWorksheet: PropTypes.bool,
  testId: PropTypes.string,
};

AddAssignment.defaultProps = {
  resourceSelection: false,
  showImageTitleInHeader: false,
  creationSource: "CLASSROOM",
  showInModal: false,
  isFromUnitPlan: false,
  isUnitRoute: false,
  isWorksheet: false,
  testId: "addAssignment",
};

export default compose(
  I18nHOC({ resource: ["common", "classRoom"] }),
  connect(mapStateToProps, mapActionCreators),
  withDerivedProps(getDerivedProps),
  graphql(getCourseStudentsFoldersQuery, {
    skip: ({ resourceSelection, courseId, isCourseFlow, isToddleLibrary2_0 }) =>
      resourceSelection || !courseId || isCourseFlow || isToddleLibrary2_0,
    name: "getCourseStudentsFolders",
    options: ({ courseId, portalType }) => ({
      /**
       * network-only fetchPolicy is used to make sure that when new students are added in class then all the students are selected by default
       * keeping cache-and-network fetchPolicy will set the stale data in state and new students will not be selected by default
       */
      fetchPolicy: "network-only",
      variables: {
        id: courseId,
        folderType: "CLASSROOM",
        portalType,
      },
    }),
    props({
      getCourseStudentsFolders,
      ownProps: { isData, isLoading, steps },
    }) {
      const courseDetails = _.get(getCourseStudentsFolders, "node", {});
      const hasClassStep = _.find(steps, ["value", "CLASS_SELECTION"]);
      const courseSubjects = _.get(courseDetails, "subjects", []);
      return {
        course: courseDetails,
        courseSubjects,
        isData: hasClassStep ? true : !_.isEmpty(courseDetails) && isData,
        isLoading:
          getCourseStudentsFolders["networkStatus"] == 1 ||
          getCourseStudentsFolders["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  graphql(getMultiCourseStudentsFoldersQuery, {
    skip: ({
      resourceSelection,
      courseId,
      preSelectedCourseIds,
      isCourseFlow,
    }) =>
      resourceSelection ||
      courseId ||
      _.isEmpty(preSelectedCourseIds) ||
      isCourseFlow,
    name: "getMultiCourseStudentsFolders",
    options: ({ preSelectedCourseIds, portalType }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        ids: preSelectedCourseIds,
        folderType: "CLASSROOM",
        portalType,
      },
    }),
    props({
      getMultiCourseStudentsFolders,
      ownProps: { preSelectedCourseIds, isData, isLoading },
    }) {
      const courseDetails = getMultiCourseStudentsFoldersFromCache({
        ids: preSelectedCourseIds,
        folderType: "CLASSROOM",
      });
      return {
        preSelectedCoursesDetails: courseDetails,
        isData: !_.isEmpty(courseDetails) && isData,
        isLoading:
          getMultiCourseStudentsFolders["networkStatus"] == 1 ||
          getMultiCourseStudentsFolders["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  graphql(getAssignmentEditDetailsQuery, {
    skip: ({ mode, assignmentId }) => mode != "edit" || !assignmentId,
    name: "getAssignmentEditDetails",
    options: ({
      assignmentId,
      portalType,
      academicYearId,
      isLearningCoursesEnabled,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        id: assignmentId,
        portalType,
        userArchivedFilters: {
          academicYearId,
        },
        // Fetch all linked assignments under assessment in new course setup only (single assessment -> multiple assignments)
        isLinkedAssignments: isLearningCoursesEnabled,
      },
    }),
    props({
      getAssignmentEditDetails,
      ownProps: {
        isData,
        isLoading,
        courseId,
        course,
        learningCourseId,
        sendAssignNotificationPreference,
        primaryGradeId,
      },
    }) {
      const data = _.get(getAssignmentEditDetails, "node", {});

      const {
        contentType,
        content,
        assignedStudents,
        deadline,
        state,
        folders,
        groupedAssignments = [],
        createdAt,
        closeSubmissionDate,
        visibility,
        metadata,
      } = data;

      const isIncludedInCourseFlow = _.get(
        content,
        "isIncludedInCourseFlow",
        false
      );

      const assignmentData = {
        ..._.pick(data, [
          "id",
          "contentType",
          "isClassDiscussionEnabled",
          "isStudentSubmissionEnabled",
          "isTeacherEvaluationEnabled",
          "isStudentEvaluationEnabled",
          "isSimilarityCheckEnabled",
          "isExcludedFromFinalGradeCalculation",
          "isPrivate",
          "isOnScreenCalculatorEnabled",
          "showStudentResponse",
          "isTimedTestEnabled",
          "isFixedStartTime",
          "isLockScreenEnabled",
          "isSafeBrowserEnabled",
          "timedTestDuration",
          "isLockSubmissionEnabled",
          "isSharedWithClassMaterial",
          "metadata",
          "isBackdateAssignment",
        ]),
        isIncludedInCourseFlow,
      };

      const linkedAssignments = _.get(content, "assignments.edges", []);

      assignmentData["courses"] = getEditAssignmentInitialCoursesState({
        course,
        courseId,
        assignedStudents,
        deadline,
        state,
        folders,
        groupedAssignments,
        closeSubmissionDate,
        visibility,
        linkedAssignments,
        isLockScreenEnabled: data.isLockScreenEnabled,
        isSafeBrowserEnabled: data.isSafeBrowserEnabled,
        timedTestDuration: minutesToHoursAndMinutes(data.timedTestDuration),
      });

      const assignmentLearningCourse = _.get(
        _.first(linkedAssignments),
        "course.learningCourse",
        []
      );
      const assignmentLearningCourseId = _.first(assignmentLearningCourse)?.id;
      const assignmentPrimaryGradeId = _.get(
        data,
        "course.primaryGrade.id",
        null
      );

      if (contentType == "ASSESSMENT") {
        assignmentData["leId"] = _.get(content, "id", "");
      } else {
        assignmentData["resource"] = content;
      }

      assignmentData["timedTestDuration"] = minutesToHoursAndMinutes(
        assignmentData["timedTestDuration"]
      );

      assignmentData["isSendAssignedNotification"] =
        sendAssignNotificationPreference ?? true;

      const assignmentContent = _.get(data, "content", {});

      const updatedAssignmentContent = {
        ...(assignmentContent || {}),
        assessmentTitle: {
          ..._.get(assignmentContent, "assessmentTitle", {}),
          value: _.trim(assignmentContent?.assessmentTitle?.value),
        },
      };

      return {
        isData: !_.isEmpty(data) && isData,
        assignmentData,
        assignmentContent: updatedAssignmentContent,
        state: _.get(state, "state"),
        publishedAt: _.get(state, "publishedAt"),
        assignedStudents,
        createdAt,
        metadata,
        learningCourseId: learningCourseId || assignmentLearningCourseId,
        primaryGradeId: primaryGradeId || assignmentPrimaryGradeId,
        isLoading:
          getAssignmentEditDetails["networkStatus"] == 1 ||
          getAssignmentEditDetails["networkStatus"] == 2 ||
          isLoading,
      };
    },
  }),
  /**
   * In new course setup, we need to fetch all staff courses(classes) of current learning-course
   * These are then filtered to keep only those courses(classes) for which...
     staff has manage assignments/gradebook permission
   * These classes are then used to select initial classes in assign modal at time of assessment/assignment creation
   */
  graphql(getStaffCoursesV2BasicDetailsQuery, {
    name: "getStaffCoursesBasicDetails",
    skip: ({ isLearningCoursesEnabled, learningCourseId }) =>
      !isLearningCoursesEnabled || _.isEmpty(learningCourseId),
    options: ({
      userId,
      portalType,
      isDpPa,
      isDpEp,
      academicYearId,
      userType,
      curriculumType,
      currentCurriculumProgramId,
      learningCourseId,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: getStaffCourseDetailsQueryVariables({
        userId,
        portalType,
        isDpPa,
        isDpEp,
        academicYearId,
        userType,
        curriculumType,
        currentCurriculumProgramId,
        learningCourseId,
      }),
    }),
    props({ getStaffCoursesBasicDetails, ownProps: { isData, isLoading } }) {
      const queryData = _.get(getStaffCoursesBasicDetails, "node", {});
      const staffCourseEdges = _.get(queryData, "coursesV2.edges", []);
      const staffCourses = _.map(staffCourseEdges, ({ node }) => node);
      const filteredStaffCourses = getFilteredCoursesBasedOnViewOrManagePermission(
        {
          courses: staffCourses,
          permissionsToCheck: getAssignmentConsumingParentModulesPermission(
            "MANAGE"
          ),
        }
      );

      return {
        filteredStaffCourses,
        isData: !_.isEmpty(queryData) && isData,
        isLoading:
          _.includes([1, 2], getStaffCoursesBasicDetails?.networkStatus) ||
          isLoading,
      };
    },
  }),
  /**
   * In new course setup, this query will fetch all classes of current learning-course...
     unlike above query which fetches only staff classes of current learning-course
   * These list of classes is used to disable "Add class" button in assign modal based on below condition...
     if courses(classes) selected in local state (assign modal) are equal to all classes in this list
   */
  graphql(getLearningCourseDetailsQuery, {
    skip: ({ learningCourseId, isLearningCoursesEnabled }) =>
      !learningCourseId || !isLearningCoursesEnabled,
    name: "getLearningCourseDetails",
    options: ({ learningCourseId, portalType }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        learningCourseId,
        portalType,
      },
    }),
    props({ getLearningCourseDetails, ownProps: { isData, isLoading } }) {
      const learningCourseDetails = _.get(getLearningCourseDetails, "node", {});
      const learningCourseClasses = _.get(
        learningCourseDetails,
        "classes",
        EMPTY_ARRAY
      );

      return {
        learningCourseClasses,
        isData: !_.isEmpty(learningCourseDetails) && isData,
        isLoading:
          _.includes([1, 2], getLearningCourseDetails?.networkStatus) ||
          isLoading,
      };
    },
  }),
  withControlParameters({
    skip: ({ isLearningCoursesEnabled, learningCourseId }) =>
      !isLearningCoursesEnabled || _.isEmpty(learningCourseId),
    skipContextSetup: true,
    options: ({
      currentCurriculumProgramId,
      learningCourseId,
      primaryGradeId,
    }) => {
      const learningCourseContexts = generateRnPContextsByLevel({
        level: "LEARNING_COURSE",
        learningCourseId,
        curriculumProgramId: currentCurriculumProgramId,
        gradeId: primaryGradeId,
      });

      return {
        variables: {
          filters: {
            module: "LEARNING_COURSE_FLOW",
            appType: ["TEACHER_WEB"],
            contexts: learningCourseContexts,
          },
        },
      };
    },
  }),
  WithOnlySettingStep,
  withLoader
)(AddAssignment);
